﻿import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import MultiPoint from 'ol/geom/MultiPoint';
import { WFS as WFSFormat, GML as GMLFormat, WKT, GeoJSON } from 'ol/format';
import { Circle as CircleStyle, Icon, Fill, Stroke, RegularShape, Style, Text } from 'ol/style.js';
import Feature from 'ol/Feature.js';
import Circle from 'ol/geom/Circle.js';
import Collection from 'ol/Collection.js';
import { Utility } from '../Utility.js';
export { ManagerTrafficSignTool };

/**
 * Class RoadBuilderTool
 */
const ManagerTrafficSignTool = function () {

    // Define this
    var myManagerTrafficSignTool = this;

    // -- begin private variable ------------------------------------------------------------------

    // Map
    this._mapSgs = null;

    //zoom search
    this._ZoomSearch = 17;

    // Utility
    this._utility = new Utility();

    // Suffix number counter for sign
    this._positionSuffix = 0;

    // Already initialize
    this._toolInitialize = false;

    // Hash that contains all reference 
    this._hashReference = {};

    // Array that contains all selected signs
    this._signsList = []

    // Buffer size for traffic sign subroad search in meters
    this._bufferSize = 500;

    // Buffer size ffor traffic sign subroad search in km
    this._bufferPoliceSizeKm = 0.5;

    // Array with all sub road near traffic sign
    this._arrayFeatureSubRoad = [];

    // Layer name for traffic sign closer
    this._layerSubRoadCloser = null;

    // FreguesiaData
    this._freguesiaData = [];

    // Feature to save
    this._featureToSave = {};

    // Feature info
    this._featureInfo = null;

    // Style sub road traffic sign closer
    this._styleSubRoadCloser = [
        new Style({
            stroke: new Stroke({
                color: 'rgba(255, 255, 0, 0.5)',
                width: 12
            }),
            fill: new Fill({
                color: 'rgba(255, 255, 0, 0.1)'
            })
        }),
        new Style({
            stroke: new Stroke({
                color: 'rgba(34, 139, 34, 0.5)',
                width: 4
            }),
            fill: new Fill({
                color: 'rgba(255, 255, 0, 0.5)'
            })
        })
    ];

    // List freguesia subroad
    this._listFreguesiaSubRoad = null;

    // List freguesia road
    this._listFreguesiaRoad = null;

    // Feature prumo selected
    this._featurePrumoSelected = null;

    // -- end private variable --------------------------------------------------------------------

    // -- begin public variable -------------------------------------------------------------------

    // Layer name for traffice sign
    this.arrayLayerNameTrafficSign = [];

    // Feature colection use in road builder tool
    this.collectionFeatureSet = new Collection();

    // Feature colection of road
    this.collectionFeatureRoadSet = new Collection();

    // Sign object information
    this.signInfo = {};

    // Prumo object information
    this.prumoInfo = {};

    // Road object information
    this.roadInfo = {};

    // Light sign object information
    this.lightSignInfo = {};

    // Support light sign object information
    this.supportLightSignInfo = {};

    // Bus stop object information
    this.busStopInfo = {};

    // Toponymic plate object information
    this.toponymicPlateInfo = {};

    // Beacon object information
    this.beaconInfo = {};

    // Guarda corpos object information
    this.guardaCorposInfo = {};

    // New jersey object information
    this.newJerseyInfo = {};

    // Pilarete object information
    this.pilareteInfo = {};

    // Marcador object information
    this.marcadorInfo = {};

    // Rail object information
    this.railInfo = {};

    // Lomba object information
    this.lombaInfo = {};

    // Light sign object information
    this.configInfo = {};

    // Array of anchor for signal in map
    this.arrayAnchorSign = [[1.3, 0.5], [1.3, 1.5], [1.3, -1.5], [-0.3, 0.5], [-0.3, 1.5], [-0.3, -1.5], [0.5, 1.5], [0.5, 1.5], [2.3, 1.5], [2.3, 2.5], [2.3, -2.5], [-1.3, 1.5], [-1.3, 2.5], [-1.3, -2.5], [1.5, 2.5], [1.5, 2.5]];

    // Adicional parameterInfo
    this.adicionalParameterInfo = {};

    // -- end public variable ---------------------------------------------------------------------


    // -- begin public method ---------------------------------------------------------------------

    /**
     * Execute action from adicional parameter
     */
    this.ExecuteAdicionalParameter = function () {
        // Get adicional parameters
        var addicionalParams = myManagerTrafficSignTool._mapSgs._settings._mapSettings.additional_params;

        // Goto signal
        if (addicionalParams && addicionalParams.context === "managerTrafficSignTool" && addicionalParams.type === "gotoSign" && addicionalParams.id) {

            // Get layer info
            var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfoOnListLayer(myManagerTrafficSignTool.signInfo.layerName);

            // Fill Adicionar parameter Info
            myManagerTrafficSignTool.adicionalParameterInfo["layerName"] = myManagerTrafficSignTool.signInfo.layerName;
            myManagerTrafficSignTool.adicionalParameterInfo["idElement"] = addicionalParams.id;
            myManagerTrafficSignTool.adicionalParameterInfo["idFeature"] = myManagerTrafficSignTool.signInfo.layerName + "." + addicionalParams.id;

            // Active layer police number
            //myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.check(myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));

            // Show police number
            myManagerTrafficSignTool._GotoElement(layerInfo, addicionalParams.id);
        }

        // Goto prumo
        if (addicionalParams && addicionalParams.context === "managerTrafficSignTool" && addicionalParams.type === "gotoPrumo" && addicionalParams.id) {

            // Get layer info
            var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfoOnListLayer(myManagerTrafficSignTool.prumoInfo.layerName);

            // Fill Adicionar parameter Info
            myManagerTrafficSignTool.adicionalParameterInfo["layerName"] = myManagerTrafficSignTool.prumoInfo.layerName;
            myManagerTrafficSignTool.adicionalParameterInfo["idElement"] = addicionalParams.id;
            myManagerTrafficSignTool.adicionalParameterInfo["idFeature"] = myManagerTrafficSignTool.prumoInfo.layerName + "." + addicionalParams.id;

            // Active layer police number
            //myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.check(myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));

            // Show police number
            myManagerTrafficSignTool._GotoElement(layerInfo, addicionalParams.id);
        }

        // Goto suporte sinal luminoso
        if (addicionalParams && addicionalParams.context === "managerTrafficSignTool" && addicionalParams.type === "gotoSuporte" && addicionalParams.id) {

            // Get layer info
            var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfoOnListLayer(myManagerTrafficSignTool.supportLightSignInfo.layerName);

            // Fill Adicionar parameter Info
            myManagerTrafficSignTool.adicionalParameterInfo["layerName"] = myManagerTrafficSignTool.supportLightSignInfo.layerName;
            myManagerTrafficSignTool.adicionalParameterInfo["idElement"] = addicionalParams.id;
            myManagerTrafficSignTool.adicionalParameterInfo["idFeature"] = myManagerTrafficSignTool.supportLightSignInfo.layerName + "." + addicionalParams.id;

            // Active layer police number
            //myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.check(myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));

            // Show police number
            myManagerTrafficSignTool._GotoElement(layerInfo, addicionalParams.id);
        }

        // Goto sinal luminoso
        if (addicionalParams && addicionalParams.context === "managerTrafficSignTool" && addicionalParams.type === "gotoSinalLuminoso" && addicionalParams.id) {

            // Get layer info
            var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfoOnListLayer(myManagerTrafficSignTool.lightSignInfo.layerName);

            // Fill Adicionar parameter Info
            myManagerTrafficSignTool.adicionalParameterInfo["layerName"] = myManagerTrafficSignTool.lightSignInfo.layerName;
            myManagerTrafficSignTool.adicionalParameterInfo["idElement"] = addicionalParams.id;
            myManagerTrafficSignTool.adicionalParameterInfo["idFeature"] = myManagerTrafficSignTool.lightSignInfo.layerName + "." + addicionalParams.id;

            // Active layer police number
            //myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.check(myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));

            // Show police number
            myManagerTrafficSignTool._GotoElement(layerInfo, addicionalParams.id);
        }

        // Goto bus stop
        if (addicionalParams && addicionalParams.context === "managerTrafficSignTool" && addicionalParams.type === "gotoBusStop" && addicionalParams.id) {

            // Get layer info
            var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfoOnListLayer(myManagerTrafficSignTool.busStopInfo.layerName);

            // Fill Adicionar parameter Info
            myManagerTrafficSignTool.adicionalParameterInfo["layerName"] = myManagerTrafficSignTool.busStopInfo.layerName;
            myManagerTrafficSignTool.adicionalParameterInfo["idElement"] = addicionalParams.id;
            myManagerTrafficSignTool.adicionalParameterInfo["idFeature"] = myManagerTrafficSignTool.busStopInfo.layerName + "." + addicionalParams.id;

            // Active layer police number
            //myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.check(myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));

            // Show police number
            myManagerTrafficSignTool._GotoElement(layerInfo, addicionalParams.id);
        }

        // Goto toponymic plate
        if (addicionalParams && addicionalParams.context === "managerTrafficSignTool" && addicionalParams.type === "gotoToponymicPlate" && addicionalParams.id) {

            // Get layer info
            var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfoOnListLayer(myManagerTrafficSignTool.toponymicPlateInfo.layerName);

            // Fill Adicionar parameter Info
            myManagerTrafficSignTool.adicionalParameterInfo["layerName"] = myManagerTrafficSignTool.toponymicPlateInfo.layerName;
            myManagerTrafficSignTool.adicionalParameterInfo["idElement"] = addicionalParams.id;
            myManagerTrafficSignTool.adicionalParameterInfo["idFeature"] = myManagerTrafficSignTool.toponymicPlateInfo.layerName + "." + addicionalParams.id;

            // Active layer police number
            //myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.check(myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));

            // Show police number
            myManagerTrafficSignTool._GotoElement(layerInfo, addicionalParams.id);
        }

        // Goto beacon
        if (addicionalParams && addicionalParams.context === "managerTrafficSignTool" && addicionalParams.type === "gotoBeacon" && addicionalParams.id) {

            // Get layer info
            var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfoOnListLayer(myManagerTrafficSignTool.beaconInfo.layerName);

            // Fill Adicionar parameter Info
            myManagerTrafficSignTool.adicionalParameterInfo["layerName"] = myManagerTrafficSignTool.beaconInfo.layerName;
            myManagerTrafficSignTool.adicionalParameterInfo["idElement"] = addicionalParams.id;
            myManagerTrafficSignTool.adicionalParameterInfo["idFeature"] = myManagerTrafficSignTool.beaconInfo.layerName + "." + addicionalParams.id;

            // Active layer police number
            //myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.check(myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));

            // Show police number
            myManagerTrafficSignTool._GotoElement(layerInfo, addicionalParams.id);
        }

        // Goto guarda corpos
        if (addicionalParams && addicionalParams.context === "managerTrafficSignTool" && addicionalParams.type === "gotoGuardaCorpos" && addicionalParams.id) {

            // Get layer info
            var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfoOnListLayer(myManagerTrafficSignTool.guardaCorposInfo.layerName);

            // Fill Adicionar parameter Info
            myManagerTrafficSignTool.adicionalParameterInfo["layerName"] = myManagerTrafficSignTool.guardaCorposInfo.layerName;
            myManagerTrafficSignTool.adicionalParameterInfo["idElement"] = addicionalParams.id;
            myManagerTrafficSignTool.adicionalParameterInfo["idFeature"] = myManagerTrafficSignTool.guardaCorposInfo.layerName + "." + addicionalParams.id;

            // Active layer police number
            //myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.check(myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));

            // Show police number
            myManagerTrafficSignTool._GotoElement(layerInfo, addicionalParams.id);
        }

        // Goto new jersey
        if (addicionalParams && addicionalParams.context === "managerTrafficSignTool" && addicionalParams.type === "gotoNewJersey" && addicionalParams.id) {

            // Get layer info
            var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfoOnListLayer(myManagerTrafficSignTool.newJerseyInfo.layerName);

            // Fill Adicionar parameter Info
            myManagerTrafficSignTool.adicionalParameterInfo["layerName"] = myManagerTrafficSignTool.newJerseyInfo.layerName;
            myManagerTrafficSignTool.adicionalParameterInfo["idElement"] = addicionalParams.id;
            myManagerTrafficSignTool.adicionalParameterInfo["idFeature"] = myManagerTrafficSignTool.newJerseyInfo.layerName + "." + addicionalParams.id;

            // Active layer police number
            //myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.check(myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));

            // Show police number
            myManagerTrafficSignTool._GotoElement(layerInfo, addicionalParams.id);
        }

        // Goto pilarete
        if (addicionalParams && addicionalParams.context === "managerTrafficSignTool" && addicionalParams.type === "gotoPilarete" && addicionalParams.id) {

            // Get layer info
            var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfoOnListLayer(myManagerTrafficSignTool.pilareteInfo.layerName);

            // Fill Adicionar parameter Info
            myManagerTrafficSignTool.adicionalParameterInfo["layerName"] = myManagerTrafficSignTool.pilareteInfo.layerName;
            myManagerTrafficSignTool.adicionalParameterInfo["idElement"] = addicionalParams.id;
            myManagerTrafficSignTool.adicionalParameterInfo["idFeature"] = myManagerTrafficSignTool.pilareteInfo.layerName + "." + addicionalParams.id;

            // Active layer police number
            //myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.check(myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));

            // Show police number
            myManagerTrafficSignTool._GotoElement(layerInfo, addicionalParams.id);
        }

        // Goto marcador
        if (addicionalParams && addicionalParams.context === "managerTrafficSignTool" && addicionalParams.type === "gotoMarcador" && addicionalParams.id) {

            // Get layer info
            var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfoOnListLayer(myManagerTrafficSignTool.marcadorInfo.layerName);

            // Fill Adicionar parameter Info
            myManagerTrafficSignTool.adicionalParameterInfo["layerName"] = myManagerTrafficSignTool.marcadorInfo.layerName;
            myManagerTrafficSignTool.adicionalParameterInfo["idElement"] = addicionalParams.id;
            myManagerTrafficSignTool.adicionalParameterInfo["idFeature"] = myManagerTrafficSignTool.marcadorInfo.layerName + "." + addicionalParams.id;

            // Active layer police number
            //myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.check(myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));

            // Show police number
            myManagerTrafficSignTool._GotoElement(layerInfo, addicionalParams.id);
        }

        // Goto rail
        if (addicionalParams && addicionalParams.context === "managerTrafficSignTool" && addicionalParams.type === "gotoRail" && addicionalParams.id) {

            // Get layer info
            var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfoOnListLayer(myManagerTrafficSignTool.railInfo.layerName);

            // Fill Adicionar parameter Info
            myManagerTrafficSignTool.adicionalParameterInfo["layerName"] = myManagerTrafficSignTool.railInfo.layerName;
            myManagerTrafficSignTool.adicionalParameterInfo["idElement"] = addicionalParams.id;
            myManagerTrafficSignTool.adicionalParameterInfo["idFeature"] = myManagerTrafficSignTool.railInfo.layerName + "." + addicionalParams.id;

            // Active layer police number
            //myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.check(myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));

            // Show police number
            myManagerTrafficSignTool._GotoElement(layerInfo, addicionalParams.id);
        }

        // Goto lomba
        if (addicionalParams && addicionalParams.context === "managerTrafficSignTool" && addicionalParams.type === "gotoLomba" && addicionalParams.id) {

            // Get layer info
            var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfoOnListLayer(myManagerTrafficSignTool.lombaInfo.layerName);

            // Fill Adicionar parameter Info
            myManagerTrafficSignTool.adicionalParameterInfo["layerName"] = myManagerTrafficSignTool.lombaInfo.layerName;
            myManagerTrafficSignTool.adicionalParameterInfo["idElement"] = addicionalParams.id;
            myManagerTrafficSignTool.adicionalParameterInfo["idFeature"] = myManagerTrafficSignTool.lombaInfo.layerName + "." + addicionalParams.id;

            // Active layer police number
            //myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.check(myManagerTrafficSignTool._mapSgs.layerTree.layerTreeObj.getNodeById(layerInfo.id.toString()));

            // Show police number
            myManagerTrafficSignTool._GotoElement(layerInfo, addicionalParams.id);
        }
    }

    /**
     * Goto to element
     * @param {object} layerInfo, All the information of the layer
     * @param {int} id, police identifier
     */
    this._GotoElement = function (layerInfo, id) {
        // Start wait
        myManagerTrafficSignTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', true);

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: layerInfo.geoserver + "/wfs",
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": layerInfo.workspace + ':' + layerInfo.layerName,
                "featureID": [id].toString(),
                'srsName': myManagerTrafficSignTool._mapSgs._settings.projection.code_,
                "outputFormat": 'application/json',
                "maxFeatures": 200
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length === 1) {
                    myManagerTrafficSignTool._mapSgs.featureToHighLight.push((new GeoJSON()).readFeatures(data)[0]);
                    var styleElement = myManagerTrafficSignTool._mapSgs._defaultHighlighStyles;
                    myManagerTrafficSignTool._mapSgs.featureToHighLight.getArray()[myManagerTrafficSignTool._mapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);

                    // Set current features in overlay
                    myManagerTrafficSignTool._mapSgs.layerHighlightOverlay.setSource(new VectorSource({ features: myManagerTrafficSignTool._mapSgs.featureToHighLight, useSpatialIndex: true }));

                    // Go to Feature
                    if (myManagerTrafficSignTool._mapSgs.layerHighlightOverlay.getSource().getFeatures().length === 1 &&
                        myManagerTrafficSignTool._mapSgs.layerHighlightOverlay.getSource().getFeatures()[0].getGeometry().getType() === "Point") {
                        myManagerTrafficSignTool._mapSgs.map.getView().fit(myManagerTrafficSignTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myManagerTrafficSignTool._mapSgs.map.getSize(), maxZoom: 12, duration: 1000 });
                    }
                    else
                        myManagerTrafficSignTool._mapSgs.map.getView().fit(myManagerTrafficSignTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myManagerTrafficSignTool._mapSgs.map.getSize() });
                }
            }

            // Stop wait
            myManagerTrafficSignTool._mapSgs._utility.ShowWait('offcanvas-map-spinner', false);
        });
    }

    /**
     * Clean traffic sign information
     */
    this.Clean = function () {
        myManagerTrafficSignTool._layerSubRoadCloser.getSource().clear();
        myManagerTrafficSignTool._arrayFeatureSubRoad = [];
        myManagerTrafficSignTool._listFreguesiaSubRoad = null;
        $('#sgs-road-name').html('');
    }

    /**
     * Clean detail traffic sign information
     */
    this.CleanDetail = function (layerName, mode) {
        $('#id-offcanvas-body-manager-traffic-sign-tool-sign-zone').empty();
        myManagerTrafficSignTool._positionSuffix = 0;
        myManagerTrafficSignTool._featureToSave = {};
        var layerPrumoNameObj = myManagerTrafficSignTool._mapSgs._utility.GetPropertyInfoInConfigArray(myManagerTrafficSignTool._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "PRUMO_LAYER_NAME");

        if (layerPrumoNameObj && layerPrumoNameObj.value && layerName == layerPrumoNameObj.value) {
            switch (mode) {
                case "create":
                    $('#id-offcanvas-body-manager-traffic-sign-tool-sign-add-button').hide();
                    break;
                case "update":
                    $('#id-offcanvas-body-manager-traffic-sign-tool-sign-add-button').show();
                    break;
                default:
                    $('#id-offcanvas-body-manager-traffic-sign-tool-sign-add-button').hide();
                    break;
            }
        }
        else {
            $('#id-offcanvas-body-manager-traffic-sign-tool-sign-add-button').hide();
        }

        $('#id-offcanvas-layer-detail-qrcopde-img-to-zoom').attr("src", "");
        $('#id-offcanvas-layer-detail-qrcopde-img').hide();
    }
       
    /**
     * Identify the nearest subroad of the traffice sign
     * @param {feature} featurePoint, feature point draw
     * @param {string} mode, mode of operation
     */
    this.IdentifySubRoadNearest = function (featurePoint, mode) {
        var coordinatePoint = null;

        if (featurePoint == undefined)
            return;

        switch (featurePoint.getGeometry().getType()) {
            case "Point":
                coordinatePoint = featurePoint.getGeometry().getCoordinates();
                break;
            case "MultiPoint":
                coordinatePoint = featurePoint.getGeometry().getCoordinates()[0];
                break;
            default:
                return;
        };

        var bufferFeature = new Feature({ geometry: new Circle(coordinatePoint, myManagerTrafficSignTool._bufferSize) });

        // Clear layer sub road police number closer
        myManagerTrafficSignTool._layerSubRoadCloser.getSource().clear();

        // Calculate interception whit sub road
        var featureInWgs84 = featurePoint.clone();
        featureInWgs84.getGeometry().transform(myManagerTrafficSignTool._mapSgs._settings.projection.code_, myManagerTrafficSignTool._mapSgs._settings.projectionWgs84.code_);

        var coordinatePointWgs84 = null;
        switch (featureInWgs84.getGeometry().getType()) {
            case "Point":
                coordinatePointWgs84 = featureInWgs84.getGeometry().getCoordinates();
                break;
            case "MultiPoint":
                coordinatePointWgs84 = featureInWgs84.getGeometry().getCoordinates()[0];
                break;
            default:
                return;
        };

        var pointCoord = turf.point(coordinatePointWgs84);
        var listIdInString = "";
        myManagerTrafficSignTool._arrayFeatureSubRoad = [];
        var geojsonFormat = new GeoJSON();
        myManagerTrafficSignTool.collectionFeatureSet.getArray().forEach(function (featureIn, index) {
            if (featureIn.getId().indexOf(myManagerTrafficSignTool.roadInfo.layerNameProcess) >= 0) {
                var featureInWgs84 = featureIn.clone();
                featureInWgs84.getGeometry().transform(myManagerTrafficSignTool._mapSgs._settings.projection.code_, myManagerTrafficSignTool._mapSgs._settings.projectionWgs84.code_);
                var featureInGeoJson = geojsonFormat.writeFeatureObject(featureInWgs84);

                var distance = turf.pointToLineDistance(pointCoord, featureInGeoJson, { units: 'kilometers' });

                if (distance <= myManagerTrafficSignTool._bufferPoliceSizeKm) {
                    myManagerTrafficSignTool._arrayFeatureSubRoad.push({
                        distance: distance,
                        feature: featureIn
                    });
                    listIdInString += featureIn.getProperties().IDTROCO + ",";
                }
            }
        });

        // Remove last
        if (myManagerTrafficSignTool._arrayFeatureSubRoad.length != 0) {
            // Order to get closet distance 
            myManagerTrafficSignTool._arrayFeatureSubRoad = myManagerTrafficSignTool._arrayFeatureSubRoad.sort((a, b) => (a.distance > b.distance) ? 1 : -1);

            // Build list of id road
            var featureRoadCloser = myManagerTrafficSignTool._arrayFeatureSubRoad[0].feature;
            myManagerTrafficSignTool._layerSubRoadCloser.getSource().addFeature(featureRoadCloser);

            // Add Road name to offcanvas-info
            var featureProperties = featureRoadCloser.getProperties();
            if (featureProperties && featureProperties[myManagerTrafficSignTool.roadInfo.columnNameRoadName] && featureProperties[myManagerTrafficSignTool.roadInfo.columnNameRoadName] != "")
                $('#sgs-road-name').html("Rua: " + featureProperties[myManagerTrafficSignTool.roadInfo.columnNameRoadName]);
            else
                $('#sgs-road-name').html('');

            // Get freguesia subtoad
            //myManagerTrafficSignTool._GetFreguesiaSubRoad(myManagerTrafficSignTool._arrayFeatureSubRoad[0].feature.getProperties().IDTROCO);
        }
        else {
            $('#sgs-road-name').html('');
            toastr["warning"]("Atenção, nenhum troço na proximidade");
        }
    }

    /**
     * Get list freguesia subroad form subroad id
     * @param {string} idSubRoad, subroad identifier
     */
    this._GetFreguesiaSubRoad = function (idSubRoad) {
        $.ajax({
            type: 'GET',
            url: '/rest/app/ManagerTrafficSignTool/GetFreguesiaFromSubRoad?idSubRoad=' + idSubRoad,
            contentType: "application/json",
            dataType: 'json',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da freguesia do sinal");
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            myManagerTrafficSignTool._listFreguesiaSubRoad = data.result.list_freguesia_troco;
                            break;
                        default:
                            toastr["error"]("Erro na obtenção da freguesia do sinal");
                            break;
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da freguesia do sinal");
            }
        });
    }

    /**
     * Get list freguesia road form road id
     * @param {string} idRoad, road identifier
     */
    this._GetFreguesiaRoad = function (idRoad) {
        $.ajax({
            type: 'GET',
            url: '/rest/app/ManagerTrafficSignTool/GetFreguesiaFromRoad?idSubRoad=' + idRoad,
            contentType: "application/json",
            dataType: 'json',
            async: false,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da freguesia do arruamento");
                }
                else {
                    switch (data.result.status) {
                        case "SUCCESS":
                            myManagerTrafficSignTool._listFreguesiaRoad = data.result.list_freguesia_troco;
                            break;
                        default:
                            toastr["error"]("Erro na obtenção da freguesia do sinal");
                            break;
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da freguesia do sinal");
            }
        });
    }

    /**
     * Get new qrCode identifier
     * @param {string} layerName, element name
     */
    this.CreateNewQrCodeIdentifier = function (layerName) {
        var qrcodeId = null;

        // Get list layer with qrcode
        var listArray = myManagerTrafficSignTool._mapSgs._utility.GetPropertyInfoInConfigArray(myManagerTrafficSignTool._mapSgs._settings.configurationInfo.propertyInfo, "ROAD_SIGN", "QRCODE", "LIST_LAYER").value.split(',');

        if (listArray.find(c => c == layerName) !== undefined) {
            // Get qrcode name field
            var qrcodeFieldName = myManagerTrafficSignTool._mapSgs._utility.GetPropertyInfoInConfigArray(myManagerTrafficSignTool._mapSgs._settings.configurationInfo.propertyInfo, "ROAD_SIGN", "QRCODE", "QRCODE_FIELD_NAME").value;

            // Create new qrcode identifier
            $.ajax({
                type: 'GET',
                url: '/rest/app/ManagerTrafficSignTool/GetNewQrCodeIdentifier?layerName=' + layerName,
                async: false,
                dataType: 'json',
                contentType: "application/json",
                success: function (data) {
                    if (!data.error && data.result.status === "SUCCESS") {
                        qrcodeId = data.result.qrcodeId;
                    }
                },
                error: function (request, status, error) {
                }
            });

            return {
                qrcodeId: qrcodeId,
                qrcodeFieldName: qrcodeFieldName
            }
        }

        return {
            qrcodeId: null
        }
    }

    /**
     * Build qrCode information
     * @param {idElement} , qrcode identifier
     * @param {suffix} , suffix for node
     * @param {refresh} , refresh panel
     */
    this.BuildQrCode = function (idElement, suffix, refresh) {
        myManagerTrafficSignTool._mapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        $.ajax({
            type: 'POST',
            url: '/rest/app/ManagerTrafficSignTool/BuildQrCodeElement?idElement=' + idElement,
            async: true,
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                var stopSpinner = true;
                if (data.error) {
                    toastr["error"]("Erro na criação do QR Code");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            if (!refresh) {
                                myManagerTrafficSignTool.GetQrcodeById(idElement, suffix);
                                stopSpinner = false;
                            }
                            else {
                                myManagerTrafficSignTool._mapSgs.DetailElement(myManagerTrafficSignTool._featureInfo);
                                stopSpinner = false;
                            }
                            break;
                        default:
                            toastr["error"]("Erro na criação do QR Code");
                    }
                }

                // Stop wait
                if (stopSpinner)
                    myManagerTrafficSignTool._mapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na criação do QR Code");

                // Stop wait
                myManagerTrafficSignTool._mapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    }

    /**
     * Get qrCode to download
     * @param {idElement} , qrcode identifier
     */
    this.GetQRCodePdf = function (idElement) {
        $.ajax({
            type: 'GET',
            url: '/rest/app/ManagerTrafficSignTool/GetQRCodePdf?idElement=' + idElement,
            async: true,
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro no donwload do QR Code");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            var qrcodeInfo = data.result;
                            var link = document.createElement('a');

                            link.href = "data:application/octet-stream;base64," + qrcodeInfo.dataPdf;
                            link.target = '_blank';
                            link.download = qrcodeInfo.fileName;
                            link.click();
                            break;
                        default:
                            toastr["error"]("Erro no donwload do QR Code");
                    }
                }

                // Stop wait
                myManagerTrafficSignTool._mapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro no donwload do QR Code");

                // Stop wait
                myManagerTrafficSignTool._mapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    }

    /**
     * Unlink sign of prumo
     * @param {idSign} , sign identifier
     * @param {idPrumo} , prumo identifier
     * @param {targetId} , html identifier to remove sign
     */
    this.UnLinkSignToPrumo = function (idSign, idPrumo, targetId) {
        
        $.ajax({
            type: 'GET',
            url: '/rest/app/ManagerTrafficSignTool/GetUnLinkSignalFromPrumo?idSignal=' + idSign,
            async: true,
            // data: JSON.stringify(signToPrumo),
            dataType: 'json',
            contentType: "application/json",
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro ao desassociar sinal do prumo");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            // reload signals list
                            myManagerTrafficSignTool.linkSignToPrumoParams.loadDataGrid();

                            // reload layers prumos and signals
                            myManagerTrafficSignTool.RefreshSignalingLayers();

                            let feature = myManagerTrafficSignTool._mapSgs._featureInfoFocus.feature;
                            const idLayer = myManagerTrafficSignTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(myManagerTrafficSignTool.prumoInfo.layerName)[0].id;

                            myManagerTrafficSignTool._mapSgs.DetailElement({
                                id: feature.getId().split(".")[1],
                                feature: feature,
                                idLayer: idLayer,
                                mode: 'update',
                                fromMap: true,
                                featurePrumo: feature
                            });

                            break;
                        default:
                            toastr["error"]("Erro ao desassociar sinal do prumo");
                    }
                }

                // Stop wait
                myManagerTrafficSignTool._mapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro ao desassociar sinal do prumo");

                // Stop wait
                myManagerTrafficSignTool._mapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    }

    /**
     * Link sign to prumo
     * @param {any} idPrumo
     * @param {any} listIdSign
     */
    this.LinkSignToPrumo = function (idPrumo, listIdSign, onSuccess) {

        const idMask = 'id-offcanvas-layer-detail-spinner';

        myManagerTrafficSignTool._mapSgs._utility.ShowWait(idMask, true);

        if (listIdSign) {

            const errorMsg = "Erro ao atribuir o sinal ao prumo";

            $.ajax({
                type: 'POST',
                url: '/ManagerTrafficSignTool/LinkSignToPrumo',
                async: false,
                data: {
                    IdPrumo: idPrumo,
                    idSignals: Array.isArray(listIdSign) ? listIdSign : [listIdSign.id]
                },
                success: function (data) {
                    if (data.error) {
                        toastr["error"](errorMsg);
                    }
                    else {
                        switch (data.result.status) {
                            case 'SUCCESS':
                                if (onSuccess) {
                                    onSuccess();
                                }
                                break;
                            case 'ERROR':
                                toastr["error"](errorMsg);
                                break;
                            default:
                        }
                    }
                    myManagerTrafficSignTool._mapSgs._utility.ShowWait(idMask, false);
                },
                error: function (request, status, error) {
                    toastr["error"](errorMsg);
                    myManagerTrafficSignTool._mapSgs._utility.ShowWait(idMask, false);
                }
            });
        }
    }

    /**
     * Build type sign select
     * @param {any} layerName
     * @param {any} objColumn
     * @param {any} featureInfo
     */
    this.BuildTypeSignZone = function (layerName, objColumn, featureInfo, suffix, value) {
        var elementId = 'id-traffic-sign' + suffix + "-" + objColumn.column_name;
        var idFormField = 'id-form-edit-layer-detail-field' + suffix;
        var idElementField = 'id-offcanvas-body-layer-detail-field' + suffix;
        var idSelectTipoSinal = 'prop-' + objColumn.column_name + suffix;

        // Build combo for sub type signal vertical
        var hiddenCol = false;
        var readOnly = (featureInfo.mode !== 'create' && featureInfo.mode !== "update") ? true : false;
        $('#' + idFormField).append($(
            '<div class="form-group offcanvas-body-layer-detail-row' + (hiddenCol ? ' hidden' : '') + ((readOnly !== 'readonly') ? ' write' : '') + '">'
            + '<label for="' + idSelectTipoSinal + '">Tipo Sinal</label>'
            + ' <select id="' + idSelectTipoSinal + '" class="form-control"><option></option></select>' +
            + '</div>'
        ));

        var comboArraySubTipoSinal = myManagerTrafficSignTool._hashReference["listSubTipoSinalVertical"];

        myManagerTrafficSignTool._mapSgs._utility.FillSelect(idSelectTipoSinal, comboArraySubTipoSinal, "description", "cod_ref");

        // Evento on change 
        $('#' + idSelectTipoSinal).on("changed.bs.select", function () {
            if ($('#' + idSelectTipoSinal).val() !== "") {
                myManagerTrafficSignTool._CreateSignZone($('#' + idSelectTipoSinal).val(), value, elementId, elementIdSelected, suffix, objColumn.column_name);
            }
        });

        // Combo sub type signal vertical
        var elementIdSelected = elementId + "-selected";
        let signsElement = '<div class="form-group offcanvas-body-layer-detail-row">'
            + '<span style="font-weight: bold;">Sinais</span>'
            + '<div id="' + elementIdSelected + '"></div>'
            + '<div id="' + elementId + '" class="traffic-sign-group ' + (readOnly ? 'ol-hidden' : '') + '" ></div>'
            + '<div>';
        $('#' + idFormField).append(signsElement);

        // Create sign zone
        myManagerTrafficSignTool._CreateSignZone($('#' + idSelectTipoSinal).val(), value, elementId, elementIdSelected, suffix, objColumn.column_name);
    }

    /**
     * Build freguesia field
     * @param {any} layerName
     * @param {any} objColumn
     * @param {any} featureInfo
     * @param {any} suffix
     * @param {any} value
     */
    this.BuildFreguesiaField = function (layerName, objColumn, featureInfo, suffix, value) {
        var idFormField = 'id-form-edit-layer-detail-field' + suffix;
        var dicofre = "";
        var freguesiaName = "";
        var idFreguesiaNameElement = "prop_freguesia" + objColumn.column_name + suffix;;
        var idDicofreElement = "prop_" + objColumn.column_name + suffix;

        if (value === null || value === undefined || value === '') {
            if (myManagerTrafficSignTool._listFreguesiaSubRoad !== null && myManagerTrafficSignTool._listFreguesiaSubRoad[0] !== undefined) {
                dicofre = myManagerTrafficSignTool._listFreguesiaSubRoad[0].dicofre;
                freguesiaName = myManagerTrafficSignTool._listFreguesiaSubRoad[0].freguesia;
            }
            else {
                switch (layerName) {
                    case "sinalizacao_vertical":
                        var idFreguesiaNameElementNoSuffix = "prop_freguesia" + objColumn.column_name;
                        var idDicofreElementNoSuffix = "prop_" + objColumn.column_name;
                        dicofre = $('#' + idDicofreElementNoSuffix).val();
                        freguesiaName = $('#' + idFreguesiaNameElementNoSuffix).val();
                        break;
                }
            }
        }
        else {
            if (myManagerTrafficSignTool._listFreguesiaSubRoad !== null && myManagerTrafficSignTool._listFreguesiaSubRoad[0] !== undefined) {
                dicofre = myManagerTrafficSignTool._listFreguesiaSubRoad[0].dicofre;
                freguesiaName = myManagerTrafficSignTool._listFreguesiaSubRoad[0].freguesia;
            }
            else {
                var objFreguesia = myManagerTrafficSignTool._GetFreguesiaInfoByDicofre(value);
                if (objFreguesia !== undefined) {
                    dicofre = value;
                    freguesiaName = objFreguesia.freguesia;
                }
            }
        }

        $('#' + idFormField).append($(
            '<div class="form-group offcanvas-body-layer-detail-row">'
            + '<label for="prop_' + objColumn.column_name + '-view">' + objColumn.pretty_name + '</label>'
            + '<input class="form-control ' + objColumn.column_type + '-view" type="text" id="' + idFreguesiaNameElement + '" value="' + freguesiaName + '" readonly />'
            + '<input name="' + objColumn.column_name + '" class="feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="hidden" id="' + idDicofreElement + '" value="' + dicofre + '" readonly />'
            + '</div > '
        ));

    }

    /**
     * Build troco field
     * @param {any} layerName
     * @param {any} objColumn
     * @param {any} featureInfo
     * @param {any} suffix
     * @param {any} value
     */
    this.BuildTrocoField = function (layerName, objColumn, featureInfo, suffix, value) {
        var idFormField = 'id-form-edit-layer-detail-field' + suffix;
        var idTrocoNameElement = "prop_" + objColumn.column_name + suffix;

        var id_troco = -1;
        if (value === null || value === undefined || value === '') {
            if (myManagerTrafficSignTool._listFreguesiaSubRoad !== null && myManagerTrafficSignTool._listFreguesiaSubRoad[0] !== undefined) {
                id_troco = myManagerTrafficSignTool._listFreguesiaSubRoad[0].id_troco;
            }
            else {
                switch (layerName) {
                    case "sinalizacao_vertical":
                        var idTrocoNameElementNoSuffix = "prop_" + objColumn.column_name;
                        id_troco = $('#' + idTrocoNameElementNoSuffix).val();
                        break;
                }
            }
        }
        else {
            if (myManagerTrafficSignTool._listFreguesiaSubRoad !== null && myManagerTrafficSignTool._listFreguesiaSubRoad[0] !== undefined) {
                id_troco = myManagerTrafficSignTool._listFreguesiaSubRoad[0].id_troco;
            }
            else {
                id_troco = value;
            }
        }

        $('#' + idFormField).append($(
            '<div>'
            + '<input name="' + objColumn.column_name + '" class="feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="hidden"  id="' + idTrocoNameElement + '" value="' + id_troco + '" readonly />'
            + '</div > '
        ));
    }

    /**
     * Build arruamento field
     * @param {any} layerName
     * @param {any} objColumn
     * @param {any} featureInfo
     * @param {any} suffix
     * @param {any} value
     */
    this.BuildArruamentoField = function (layerName, objColumn, featureInfo, suffix, value) {
        var idFormField = 'id-form-edit-layer-detail-field' + suffix;
        var id_arruamento = "";
        var troco = "";
        var idTrocoElement = "prop_troco" + objColumn.column_name + suffix;;
        var idArruamentoElement = "prop_" + objColumn.column_name + suffix;

        if (value === null || value === undefined || value === '') {
            if (myManagerTrafficSignTool._listFreguesiaSubRoad !== null && myManagerTrafficSignTool._listFreguesiaSubRoad[0] !== undefined) {
                id_arruamento = myManagerTrafficSignTool._listFreguesiaSubRoad[0].id_arruamento;
                troco = myManagerTrafficSignTool._listFreguesiaSubRoad[0].troco;
            }
            else {
                switch (layerName) {
                    case "sinalizacao_vertical":
                        var idTrocoElementNoSuffix = "prop_troco" + objColumn.column_name;
                        var idArruamentoElementNoSuffix = "prop_" + objColumn.column_name;
                        id_arruamento = $('#' + idArruamentoElementNoSuffix).val();
                        troco = $('#' + idTrocoElementNoSuffix).val();
                        break;
                }
            }
        }
        else {
            if (myManagerTrafficSignTool._listFreguesiaSubRoad !== null && myManagerTrafficSignTool._listFreguesiaSubRoad[0] !== undefined) {
                id_arruamento = myManagerTrafficSignTool._listFreguesiaSubRoad[0].id_arruamento;
                troco = myManagerTrafficSignTool._listFreguesiaSubRoad[0].troco;
            }
            else {
                var objArruamento = myManagerTrafficSignTool._GetRoadInfoById(value);
                id_arruamento = value;
                troco = objArruamento.troco;
            }
        }

        $('#' + idFormField).append($(
            '<div class="form-group offcanvas-body-layer-detail-row">'
            + '<label for="prop_' + objColumn.column_name + '-view">' + objColumn.pretty_name + '</label>'
            + '<input class="form-control ' + objColumn.column_type + '-view" id="' + idTrocoElement + '"  type="text" value="' + troco + '" readonly />'
            + '<input name="' + objColumn.column_name + '" class="feature-field form-control ' + objColumn.column_type + '" data-name="' + objColumn.column_name + '" type="hidden"  id="' + idArruamentoElement + '" value="' + id_arruamento + '" readonly />'
            + '</div > '
        ));

    }

    /**
     * Get image qrcode
     * @param {any} idElement
     */
    this.GetQrcodeById = function (idElement, suffix) {
        myManagerTrafficSignTool._mapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        $.ajax({
            type: 'GET',
            url: '/rest/app/ManagerTrafficSignTool/GetQRCodeImgInBase64?idElement=' + idElement,
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção do QRCODE");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            $('#id-offcanvas-layer-detail-qrcopde-img-to-zoom' + suffix).attr("src", "data:image/jpeg;base64," + data.result.base64ImageQrcode);
                            $('#id-offcanvas-layer-detail-qrcopde-img-to-zoom' + suffix).attr("qr-code", idElement);
                            /*$('#id-offcanvas-layer-detail-qrcopde-img-to-zoom' + suffix).attr("data-magnify-src", "data:image/jpeg;base64," + data.result.base64ImageQrcode);*/
                            $('#id-offcanvas-layer-detail-qrcopde-img' + suffix).show();
                            $('#id-offcanvas-layer-detail-qrcopde-img-to-zoom' + suffix).show();
                            $('#id-offcanvas-layer-detail-qrcopde-no-img' + suffix).hide();
                            // Set button download qrcode
                            $('#id-offcanvas-body-layer-detail-generate-qrcode' + suffix).attr('action', 'download');
                            $('#id-offcanvas-body-layer-detail-generate-qrcode' + suffix).attr('title', 'Download QR Code');
                            $('#id-offcanvas-body-layer-detail-generate-qrcode' + suffix + ' i').attr('class', 'fa fa-download');
                            $('#id-offcanvas-body-layer-detail-generate-qrcode' + suffix).show();
                            break;
                        case "NO_QRCODE":
                            $('#id-offcanvas-layer-detail-qrcopde-img' + suffix).show();
                            $('#id-offcanvas-layer-detail-qrcopde-img-to-zoom' + suffix).hide();
                            $('#id-offcanvas-layer-detail-qrcopde-no-img' + suffix).show();
                            // Set button generate qrcode
                            $('#id-offcanvas-body-layer-detail-generate-qrcode' + suffix).attr('action', 'generate');
                            $('#id-offcanvas-body-layer-detail-generate-qrcode' + suffix).attr('title', 'Gerar QR Code');
                            $('#id-offcanvas-body-layer-detail-generate-qrcode' + suffix + ' i').attr('class', 'fa fa-qrcode');
                            $('#id-offcanvas-body-layer-detail-generate-qrcode' + suffix).show();
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na obtenção do QRCODE");
                            break;
                        default:
                    }
                }
                myManagerTrafficSignTool._mapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção do QRCODE");

                myManagerTrafficSignTool._mapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
            }
        });
    }

    /**
     * Get all sign from prumo
     * @param {feature} featurePrumo, feature prumo
     */
    this.GetAllSignPrumo = function (featurePrumo) {
        var idPrumo = featurePrumo.getId().split(".")[1];
        myManagerTrafficSignTool._featurePrumoSelected = featurePrumo;

        // Get sign layer all info
        var layerInfoAll = myManagerTrafficSignTool._mapSgs.layerTree.GetLayerAllInfoArrayByLayerSourceName(myManagerTrafficSignTool.signInfo.layerName)[0];
        if (!layerInfoAll) {
            toastr["error"]("Erro na obtenção dos sinais do prumo");

            return;
        }
        var layerInfo = layerInfoAll.layer_info;
        var listColumn = layerInfoAll.list_column;
        var typeSignInfo = listColumn.find(c => c.column_name == myManagerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign);
        if (!typeSignInfo) {
            toastr["error"]("Erro na obtenção dos sinais do prumo");

            return;
        }

        // Get reference table sign type
        var dataRefTableSignType = myManagerTrafficSignTool._mapSgs._settings._mapSettings.column_table_reference_data.table_reference_data[typeSignInfo.id_rel_layer_column_ref_metadata];
        if (!dataRefTableSignType) {
            toastr["error"]("Erro na obtenção dos sinais do prumo");

            return;
        }

        // Build title
        $('#id-offcanvas-body-manager-traffic-sign-tool-sign-zone').append('<div class="traffic-sign-title"><label>Sinais</label></div>');

        var getFeatureUrl = layerInfo.geoserver + "/wfs";
        var cqlFilter = myManagerTrafficSignTool.signInfo.columnNameIdPrumo + " == '" + idPrumo + "'";

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": layerInfo.workspace + ':' + myManagerTrafficSignTool.signInfo.layerName,
                "cql_filter": cqlFilter,
                'srsName': myManagerTrafficSignTool._mapSgs._settings.projection.code_,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    myManagerTrafficSignTool._positionSuffix = 0;
                    for (var i = 0; i < data.features.length; i++) {
                        var feature = (new GeoJSON()).readFeatures(data.features[i])[0];
                        feature.unset('geometry');

                        var idLayer = myManagerTrafficSignTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(myManagerTrafficSignTool.signInfo.layerName)[0].id;
                        var featureInfo = {
                            id: feature.getId().split(".")[1],
                            feature: feature,
                            idLayer: idLayer,
                            mode: 'update',
                            fromMap: true,
                            featurePrumo: featurePrumo
                        };

                        myManagerTrafficSignTool._positionSuffix = myManagerTrafficSignTool._positionSuffix + 1;
                        var suffix = "-" + myManagerTrafficSignTool._positionSuffix;

                        // Store feature for save later
                        myManagerTrafficSignTool._featureToSave[suffix] = featureInfo;

                        // Build new sign
                        var urlImageSign = feature.getProperties()[myManagerTrafficSignTool.signInfo.signInfoConfig.column_name_url_img];
                        var idTypeSign = feature.getProperties()[myManagerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign];
                        var idSign = feature.getProperties()[myManagerTrafficSignTool.signInfo.signInfoConfig.column_name_id_sign];
                        var typeSignDescription = dataRefTableSignType.find(c => c.id == idTypeSign).value;
                        myManagerTrafficSignTool._AddNewSign(myManagerTrafficSignTool.signInfo.layerName, suffix, "update", idSign, idPrumo, urlImageSign, typeSignDescription);

                        // Add field
                        myManagerTrafficSignTool._mapSgs.DetailElementField(featureInfo, suffix);
                    }
                }
            }
        });
    };

    /**
     * Detail elemento for sign only
     */
    this.DetailElementSign = function (featureInfo) {
        // Alter attributes featureInfo
        featureInfo.mode = "update";

        // Get sign layer all info
        var layerInfoAll = myManagerTrafficSignTool._mapSgs.layerTree.GetLayerAllInfoArrayByLayerSourceName(myManagerTrafficSignTool.signInfo.layerName)[0];
        if (!layerInfoAll) {
            toastr["error"]("Erro na obtenção dos sinais do prumo");

            return;
        }
        var layerInfo = layerInfoAll.layer_info;
        var listColumn = layerInfoAll.list_column;
        var typeSignInfo = listColumn.find(c => c.column_name == myManagerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign);
        if (!typeSignInfo) {
            toastr["error"]("Erro na obtenção dos sinais do prumo");

            return;
        }

        // Get reference table sign type
        var dataRefTableSignType = myManagerTrafficSignTool._mapSgs._settings._mapSettings.column_table_reference_data.table_reference_data[typeSignInfo.id_rel_layer_column_ref_metadata];
        if (!dataRefTableSignType) {
            toastr["error"]("Erro na obtenção dos sinais do prumo");

            return;
        }

        // Build new sign
        var urlImageSign = featureInfo.feature.getProperties()[myManagerTrafficSignTool.signInfo.signInfoConfig.column_name_url_img];
        var idTypeSign = featureInfo.feature.getProperties()[myManagerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign];
        var idSign = featureInfo.feature.getProperties()[myManagerTrafficSignTool.signInfo.signInfoConfig.column_name_id_sign];
        var idPrumo = featureInfo.feature.getProperties()[myManagerTrafficSignTool.signInfo.signInfoConfig.columnNameIdPrumo];
        var typeSignDescription = dataRefTableSignType.find(c => c.id == idTypeSign).value;
        myManagerTrafficSignTool._AddNewSign(myManagerTrafficSignTool.signInfo.layerName, "", "update", idSign, idPrumo, urlImageSign, typeSignDescription);

        // Add field
        myManagerTrafficSignTool._mapSgs.DetailElementField(featureInfo, "");
    }

    /**
     * Get all sign not in prumo from typeSign
     */
    this.GetAllSignNotInPrumoFromTypeSign = function (idTypeSign, urlImg, typeSignDescription) {
        // Get sign layer all info
        var layerInfoAll = myManagerTrafficSignTool._mapSgs.layerTree.GetLayerAllInfoArrayByLayerSourceName(myManagerTrafficSignTool.signInfo.layerName)[0];
        if (!layerInfoAll) {
            toastr["error"]("Erro na obtenção dos sinais do prumo");

            return;
        }
        var layerInfo = layerInfoAll.layer_info;
        var listColumn = layerInfoAll.list_column;
        var typeSignInfo = listColumn.find(c => c.column_name == myManagerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign);
        if (!typeSignInfo) {
            toastr["error"]("Erro na obtenção dos sinais do prumo");

            return;
        }

        // Build title
        $('#id-offcanvas-body-manager-traffice-sign-add-not-in-prumo').append('<div class="traffic-sign-title"><label>Seleccione um sinal</label></div>');

        var getFeatureUrl = layerInfo.geoserver + "/wfs";
        var cqlFilter = myManagerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign + " == " + idTypeSign + " and  installed <> true";

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": layerInfo.workspace + ':' + myManagerTrafficSignTool.signInfo.layerNameSave,
                "cql_filter": cqlFilter,
                'srsName': myManagerTrafficSignTool._mapSgs._settings.projection.code_,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    myManagerTrafficSignTool._positionSuffix = 0;
                    for (var i = 0; i < data.features.length; i++) {
                        var feature = (new GeoJSON()).readFeatures(data.features[i])[0];
                        feature.unset('geometry');

                        var idLayer = myManagerTrafficSignTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(myManagerTrafficSignTool.signInfo.layerNameSave)[0].id;
                        var featureInfo = {
                            id: feature.getId().split(".")[1],
                            feature: feature,
                            idLayer: idLayer,
                            mode: 'update',
                            fromMap: true
                        };

                        myManagerTrafficSignTool._positionSuffix = myManagerTrafficSignTool._positionSuffix + 1;
                        var suffix = "-" + myManagerTrafficSignTool._positionSuffix;

                        // Store feature for save later
                        myManagerTrafficSignTool._featureToSave[suffix] = featureInfo;

                        // Build new sign
                        var idSign = feature.getProperties()[myManagerTrafficSignTool.signInfo.signInfoConfig.column_name_id_sign];
                        myManagerTrafficSignTool._AddNewSign(layerName, suffix, "read", idSign, null, urlImg, typeSignDescription);

                        // Add field
                        myManagerTrafficSignTool._mapSgs.DetailElementField(featureInfo, suffix);
                    }
                }
            }
        });
    };

    /**
     * Update all sign of a prumo with prumo info
     */
    this.UpdateSignInfoFromPrumo = function (featurePrumo) {
        var idLayer = myManagerTrafficSignTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(myManagerTrafficSignTool.signInfo.layerName)[0].id;
        var layerInfoFeature = myManagerTrafficSignTool._mapSgs.layerTree.layerInfo.dict_layer_info[idLayer].layer_info;

        var getFeatureUrl = layerInfoFeature.geoserver + "/wfs";
        var idPrumo = featurePrumo.getId().split(".")[1];

        var cqlFilter = myManagerTrafficSignTool.signInfo.columnNameIdPrumo + " == '" + idPrumo + "'";

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": layerInfoFeature.workspace + ':' + myManagerTrafficSignTool.signInfo.layerNameSave,
                "cql_filter": cqlFilter,
                'srsName': myManagerTrafficSignTool._mapSgs._settings.projection.code_,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features) {
                if (data.features.length > 0) {
                    myManagerTrafficSignTool._positionSuffix = 0;
                    for (var i = 0; i < data.features.length; i++) {
                        var feature = (new GeoJSON()).readFeatures(data.features[i])[0];
                        //feature.unset('geometry');

                        //var featurePrumoProperties = featurePrumo.getProperties();

                        //// Set attribute to update
                        //var arrayAttribute = eval(myManagerTrafficSignTool.signInfo.signInfoConfig.list_column_to_update);
                        //var propertyToUpdate = {};
                        //for (var i = 0; i < arrayAttribute.length; i++) {
                        //    var attribute = arrayAttribute[i];
                        //    propertyToUpdate[attribute[0]] = featurePrumoProperties[attribute[1]];
                        //}
                        //feature.setGeometry(featurePrumo.getGeometry().getCoordinates());
                        //feature.setProperties(propertyToUpdate);

                        //myManagerTrafficSignTool._mapSgs._TransactWFS('update', feature, layerInfoFeature, "1");
                        myManagerTrafficSignTool._SaveFeatureSign('update', feature, featurePrumo, myManagerTrafficSignTool.signInfo.layerNameSave, layerInfoFeature, null, false, true);
                    }
                }
            }

            // Stop wait
            myManagerTrafficSignTool._mapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
        });
    };

    this.BuildTrafficSignColumnInfo = function (idPrumo) {
        $.ajax({
            type: 'GET',
            url: '/rest/app/ManagerTrafficSignTool/GetAllSignFromPrumo',
            async: true,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro de carregamento da informação de referência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            myManagerTrafficSignTool._hashReference['listTipoSinalVertical'] = data.result.listTipoSinalVertical;
                            myManagerTrafficSignTool._hashReference['listSubTipoSinalVertical'] = data.result.listSubTipoSinalVertical;
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro de carregamento da informação de referência");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de carregamento da informação de referência");
            }
        });
    }

    // -- end public method -----------------------------------------------------------------------

    // -- begin private method --------------------------------------------------------------------

    /**
     * Create sign zone
     * @param {any} valueSubTipoSinal
     * @param {any} value
     * @param {any} elementId
     * @param {any} elementIdSelected
     * @param {any} suffix
     * @param {any} columnName
     */
    this._CreateSignZone = function (valueSubTipoSinal, value, elementId, elementIdSelected, suffix, columnName) {
        var comboArrayAllTipoSinal = myManagerTrafficSignTool._hashReference["listTipoSinalVertical"];

        if (valueSubTipoSinal !== '') {
            comboArrayAllTipoSinal = comboArrayAllTipoSinal.filter(function (data) {
                return data.sub_tipo_sinal === valueSubTipoSinal;
            });
        }

        $("#" + elementId).empty();

        var count = 0;
        var idElementImg = 'id-offcanvas-body-layer-detail-img' + suffix;
        comboArrayAllTipoSinal.forEach(element => {
            let signElementId = elementId + "_item_" + element.cod_sinal;
            let signElementDiv = signElementId + "_div";

            let isChecked = (value === element.cod_sinal) ? 'checked' : '';

            if (isChecked === 'checked') {
                $('#' + elementIdSelected).append($(`<div id="${signElementDiv}" style="margin: 10px 10px 10px 0px;">
                                            <label for="${signElementId}"></label>
                                            <input type="hidden" class="feature-field" name="${columnName}" id="prop-${columnName}"/>
                                            <img src="/images/traffic-signs2/${element.cod_sinal}.gif" alt="${element.cod_sinal}" height="20" width="20" style="position: relative;bottom: 1px;">
                                            ${element.cod_sinal}</div>`));
                $('#' + elementIdSelected + " input").val(element.cod_sinal);

                // Change image title
                $('#' + idElementImg).attr("src", "/images/traffic-signs2/" + value + ".gif");
                $('#' + idElementImg).attr("alt", value);
                $('#' + idElementImg).show();
            }

            var elementTrafficSign = $(`<div id="${signElementDiv}" class="col col-md-6" style="margin-bottom: 5px;padding: 0px;">
                                        <input type="radio" id="${signElementId}" column-name="${columnName}" value="${element.cod_sinal}" ${isChecked}>
                                        <label for="${signElementId}" class="traffic-sign-radio-label"></label>
                                        <img src="/images/traffic-signs2/${element.cod_sinal}.gif" alt="${element.cod_sinal}" height="20" width="20">
                                        ${element.cod_sinal}</div>`);

            if (count % 2 === 0) {
                $('#' + elementId).append($('<div id="' + elementId + '-' + count + '" class="col col-md-12"></div>'));
                $('#' + elementId + '-' + count).append(elementTrafficSign);
            }
            else {
                $('#' + elementId + '-' + (count - 1)).append(elementTrafficSign);
            }

            count++;
        });

        if (value == null || value === undefined || value == '') {
            $('#' + idElementImg).hide();
        }

        // event on radio choose change
        $('#' + elementId + ' input[column-name="' + columnName + '"]').off().on('change', function () {
            $('#' + elementIdSelected).empty();
            var value = $(this).parent().find('input').val();

            var nodeElementChecked = $(`<div id="${$(this).parent()[0].id}" style="margin: 10px 10px 10px 0px;">
                                            <label for="${$(this).parent().find('label').attr('for')}"></label>
                                            <input type="hidden" class="feature-field" name="${columnName}" id="prop-${columnName}"/>
                                            <img src="/images/traffic-signs2/${value}.gif" alt="${value}" height="20" width="20" style="position: relative;bottom: 1px;"> 
                                            ${value}</div>`);

            $('#' + elementIdSelected).append(nodeElementChecked);
            $('#' + elementIdSelected + " input").val(value);

            // Change image title
            if (value && value !== '') {
                var idElementImg = 'id-offcanvas-body-layer-detail-img' + suffix;
                $('#' + idElementImg).attr("src", "/images/traffic-signs2/" + value + ".gif");
                $('#' + idElementImg).attr("alt", value);
                $('#' + idElementImg).show();
            }
        });
    }

    /**
     * Construção da informação dos alarmes
     * @param {any} jsonValue
     */
    this.BuildAlarmInfo = function (jsonValue, suffix) {
        var listAlarm = JSON.parse(jsonValue);
        var idElementAlarm = 'id-offcanvas-body-layer-detail-alarm-list' + suffix;
        $('#' + idElementAlarm).empty();

        listAlarm.forEach(alarm => {

            let columnIcons = '<div class="col-md-1"><span class="fa fa-warning" style="color: orange;font-size: 16px;margin-right: 10px;"></span></div>';
            const isAlarmManually = alarm.cod_alarm_rule_predefined == 'WARNING_ALARM_MANUALLY';

            if (isAlarmManually) {
                columnIcons = '<div class="col-md-1"><span class="fa fa-edit id-offcanvas-body-layer-detail-alarm-manually-btn-edit" data-id-alarm="' + alarm.id_alarm_rule + '" data-name-alarm="' + alarm.name + '" data-description-alarm="' + alarm.description + '" style="color: orange;font-size: 16px;margin-right: 10px;"></span></div>';
            }

            $('#' + idElementAlarm).append($('<div class="row" style="padding-bottom: 15px;">' +
                columnIcons +
                '<div class="col-md-4">' + alarm.date_alarm + '</div>' +
                '<div class="col-md-6" title="' + alarm.description + '">' + alarm.name + '</div>' +
                '</div>'));
        });

        $('.id-offcanvas-body-layer-detail-alarm-manually-btn-edit').off('click').on('click', (event) => {

            $('input[name="alarm_manually_name"]').val(event.target.attributes.getNamedItem('data-name-alarm').value);
            $('textArea[name="alarm_manually_description"]').val(event.target.attributes.getNamedItem('data-description-alarm').value);

            $('#id-offcanvas-body-layer-detail-alarm-manually-btn-remove').attr('data-id-alarm', event.target.attributes.getNamedItem('data-id-alarm').value);
            $('#id-offcanvas-body-layer-detail-alarm-manually-btn-save').attr('data-id-alarm', event.target.attributes.getNamedItem('data-id-alarm').value);

            $('#id-offcanvas-body-layer-detail-alarm-manually-btn-remove').show();
            $('#id-offcanvas-body-layer-detail-alarm-manually-btn-save').show();

            $('#id-offcanvas-body-layer-detail-alarm-manually-zone').show();
        });
    }

    /**
     * Add new sign
     */
    this._AddNewSign = function (layerName, suffix, mode, idSign, idPrumo, urlImageSign, typeSignDescription) {
        // -- Create html structure ---------------------------------------------------------------

        // Build title
        var idElementZone = 'id-offcanvas-body-layer-detail-zone' + suffix;
        var idElementTitle = 'id-offcanvas-body-layer-detail-title' + suffix;
        var idElementTitleLabel = 'id-offcanvas-body-layer-detail-title-label' + suffix;
        var idElementTitleLabelId = 'id-offcanvas-body-layer-detail-title-label-id' + suffix;
        var idElementImg = 'id-offcanvas-body-layer-detail-img' + suffix;
        var $elementZone = null;
        var $elementZone = $('<div id="' + idElementZone + '">' +
            '<div target-id="' + idElementTitle + '" class="offcanvas-collapse" style="height: 50px;text-align: center;">' +
            '<div class="col-md-2" style="padding:0">' +
            '<img id="' + idElementImg + '" src="' + urlImageSign + '" alt="" width="30" height="30">' +
            '</div>' +
            '<div class="col-md-8" style="padding:0">' +
            '<label id="' + idElementTitleLabel + '" style="padding-left: 20px;font-size:10px;margin-bottom: 0px;">' + typeSignDescription + '</label>' +
            '<label id="' + idElementTitleLabelId + '" style="padding-left: 20px;font-size:12px;;margin-bottom: 0px;">' + idSign.toString().padStart(5, '0') + '</label>' +
            '</div>' +
            '<div class="col-md-2" style="padding:0">' +
            '<i class="fa fa-chevron-down option-title-go-right-open"></i>' +
            '</div>' +
            '</div>' +
            '<div id="' + idElementTitle + '" class="offcanvas-block" style="display: none">' +
            '</div>' +
            '</div>');
        $('#id-offcanvas-body-manager-traffic-sign-tool-sign-zone').append($elementZone);

        // Build field
        var idElementField = 'id-offcanvas-body-layer-detail-field' + suffix;
        var idFormField = 'id-form-edit-layer-detail-field' + suffix;
        $('#' + idElementTitle).append($('<div class="offcanvas-separator2"></div>'));
        var $elementZoneField = $('<div target-id="' + idElementField + '" class="offcanvas-collapse">' +
            '<i class="fa fa-chevron-down option-title-go-right-open"></i>' +
            '<label>Campos</label>' +
            '</div>' +
            '<div id="' + idElementField + '" class="offcanvas-block" style="display: none">' +
            '<form id="' + idFormField + '"></form>' +
            '</div>');
        $('#' + idElementTitle).append($elementZoneField);

        // Alarme Zone
        if (mode != "create") {
            var idElementAlarm = 'id-offcanvas-body-layer-detail-alarm' + suffix;
            $('#' + idElementTitle).append($('<div class="offcanvas-separator2"></div>'));
            var $elementZoneAlarm = $('<div target-id="' + idElementAlarm + '" class="offcanvas-collapse">' +
                '<i class="fa fa-chevron-down option-title-go-right-open"></i>' +
                '<label>Alarmes Activos</label>' +
                '</div>' +
                '<div id="' + idElementAlarm + '" class="offcanvas-block" style="display: none">' +
                '<label style="font-size: 10px;margin-bottom: 0px;font-weight: 100;width: 100%;text-align: center;">Nenhum alarme Activo</label>' +
                '</div>');
            $('#' + idElementTitle).append($elementZoneAlarm);
        }

        // Image qrCode
        if (mode != "create") {
            var idElementImgDiv = "id-offcanvas-layer-detail-qrcopde-img" + suffix;
            var idElementImgZone = "id-offcanvas-layer-detail-qrcopde-img-zone" + suffix;
            var idElementImg = "id-offcanvas-layer-detail-qrcopde-img-to-zoom" + suffix;
            var idElementNoImg = "id-offcanvas-layer-detail-qrcopde-no-img" + suffix;
            $('#' + idElementTitle).append($('<div class="offcanvas-separator2"></div>'));
            var $elementQrcodeImg = $('<div id="' + idElementImgDiv + '" class="ol-hidden" style="text-align: center;display: none;">' +
                '<div id="' + idElementImgZone + '" style="margin-bottom: 20px;">' +
                '<img id="' + idElementImg + '" class="zoom" width="100" height="100" src="" data-magnify-src="" />' +
                '<label id="' + idElementNoImg + '" style="display: none;font-style: italic;font-size: 11px;font-weight: 100;">Sem QR Code Gerado</label>' +
                '</div>' +
                '</div>');
            $('#' + idElementTitle).append($elementQrcodeImg);
        }

        // Sign button
        var idElementButtonUnlink = 'id-offcanvas-body-layer-detail-unlink-sign' + suffix;
        var idElementButtonGenerateQrCode = 'id-offcanvas-body-layer-detail-generate-qrcode' + suffix;
        var idElementButtonSave = 'id-offcanvas-body-layer-detail-save-sign' + suffix;
        if (mode != "read") {
            $('#' + idElementTitle).append($('<div class="offcanvas-separator2"></div>'));
            var $elementButton = $('<div class="row" style="margin-bottom: 20px;">' +
                '<div class="col col-md-12 col-xs-12" style="text-align: center;">' +
                '<button type="button" id="' + idElementButtonUnlink + '" sign-id="' + idSign + '" prumo-id="' + idPrumo + '" target-id="' + idElementZone + '" title="Desinstalar sinal" class="btn btn-primary pull-right" style="margin-right: 20px;">' +
                '<i class="fa fa-unlink"></i>' +
                '</button>' +
                '<button type="button" id="' + idElementButtonGenerateQrCode + '" mode="' + mode + '" suffix="' + suffix + '" action="download" title="Download QR Code" class="btn btn-primary" style="display:none;">' +
                '<i class="fa fa-download"></i>' +
                '</button>' +
                '<button type="button" id="' + idElementButtonSave + '" mode="' + mode + '" suffix="' + suffix + '" target-id="' + idFormField + '" title="Gravar sinal" class="btn btn-primary pull-left" style="margin-left: 20px;">' +
                '<i class="fa fa-save"></i>' +
                '</button>' +
                '</div>' +
                '</div>');
            $('#' + idElementTitle).append($elementButton);
        }

        // Attachment
        if (mode != "create") {
            $('#' + idElementTitle).append($('<div class="offcanvas-separator2"></div>'));
            var idElementAttachAncho = 'id-offcanvas-body-layer-detail-attachment-anchor' + suffix;
            var idElementAttachDetail = 'id-offcanvas-body-layer-detail-attachment' + suffix;
            var idElementAttachSpinner = 'id-offcanvas-body-layer-detail-attachment-spinner' + suffix;
            var idElementAttachAdd = 'id-offcanvas-body-layer-detail-attachment-add' + suffix;
            var idElementAttachDetailBody = 'id-offcanvas-body-layer-detail-attachment-body' + suffix;
            var idElementAttachZone = 'id-offcanvas-body-layer-detail-attachment-zone' + suffix;
            var idElementAttachForm = 'id-offcanvas-body-layer-detail-attachment-form' + suffix;
            var classNumberOfFile = 'offcanvas-body-layer-detail-attachment-info-td' + suffix;
            var elementAttachStr = '<div>' +
                '<div id="' + idElementAttachAncho + '" target-id="' + idElementAttachDetail + '" class="offcanvas-collapse hide-on-creation">' +
                '<i class="fa fa-chevron-down option-title-go-right-open"></i>' +
                '<label>Anexos</label>' +
                '<div id="' + idElementAttachSpinner + '" class="loader map-spinner ol-hidden">' +
                '<div class="preloader">' +
                '<div class="spinner-layer pl-red">' +
                '<div class="circle-clipper left">' +
                '<div class="circle"></div>' +
                '</div>' +
                '<div class="circle-clipper right">' +
                '<div class="circle"></div>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '<p>Aguarde...</p>' +
                '</div>' +
                '</div>' +
                '<div id ="' + idElementAttachDetail + '" class="offcanvas-block hide-on-creation" style="display: none">' +
                '<div class="row">' +
                '<div class="col col-md-9 col-xs-9 ' + classNumberOfFile + '">' +
                '<label>Número de anexos: <span>-</span></label>' +
                '</div>';
            if (mode != "read" && myManagerTrafficSignTool._mapSgs._settings._mapSettings.operation_visible.Upload) {
                elementAttachStr += '<div class="col col-md-3 col-xs-3 offcanvas-body-layer-detail-attachment-add-td">' +
                    '<button type="button" id="' + idElementAttachAdd + '" title="Adicionar Anexo" class="btn btn-primary pull-right">' +
                    '<i class="fa fa-plus"></i>' +
                    '</button>' +
                    '</div>';
            }
            elementAttachStr += '</div>' +
                '<div class="row">' +
                '<div id="' + idElementAttachDetailBody + '" class="">' +
                '<div id="' + idElementAttachZone + '" class="row offcanvas-body-layer-detail-attachment-zone">' +
                '<form id="' + idElementAttachForm + '" action="" class="" role="form" method="post" style="color: black;height:100%"></form>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>';
            var $elementAttach = $(elementAttachStr);
            $('#' + idElementTitle).append($elementAttach);
        }


        // Last separator
        $('#id-offcanvas-body-manager-traffic-sign-tool-sign-zone').append($('<div id="' + idElementZone + '-separator" class="offcanvas-separator"></div>'));

        // Hide button on create
        if (mode == "create") {
            $('#' + idElementButtonGenerateQrCode).hide();
            $('#' + idElementButtonUnlink).hide();
            $('#' + idElementImg).hide();
        }

        // -- Create field ------------------------------------------------------------------------

        // Create feature with same coordinadres
        var coodinates = myManagerTrafficSignTool._mapSgs._featureInfoFocus.feature.getGeometry().getCoordinates();

        var featureSign = new Feature({
            geometry: new MultiPoint(coodinates),
        });

        // Build field
        if (mode == "create") {
            var idLayer = myManagerTrafficSignTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(layerName)[0].id;
            var featureInfo = {
                id: -1,
                feature: featureSign,
                idLayer: idLayer,
                mode: 'create',
                fromMap: true,
                idPrumo: idPrumo
            };

            myManagerTrafficSignTool._mapSgs.DetailElementField(featureInfo, suffix);
        }

        // -- Event -------------------------------------------------------------------------------

        // Event Collapse/open info in element detail
        $('#' + idElementZone).on('click', '.offcanvas-collapse', function () {
            var idNodeToCollapse = this.getAttribute('target-id');
            $(this).find('i').toggleClass('fa-chevron-down fa-chevron-up');
            // Close all other info

            $('#' + idNodeToCollapse).toggle('ol-hidden');
        });

        // Event unlink and qrcode Sign
        if (mode == "update") {
            $('#' + idElementButtonUnlink).on('click', function () {
                var idSign = $(this).attr('sign-id');
                var idPrumo = $(this).attr('prumo-id');
                var targetId = $(this).attr('target-id');

                myManagerTrafficSignTool._mapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);
                myManagerTrafficSignTool.UnLinkSignToPrumo(idSign, idPrumo, targetId);
            });

            // Event generate qr code
            $('#' + idElementButtonGenerateQrCode).on('click', function () {
                var mode = $(this).attr('mode');
                var action = $(this).attr('action');
                var suffixToSave = $(this).attr('suffix');

                switch (mode) {
                    case "read":
                    case "update":
                        var featureInfoToSave = myManagerTrafficSignTool._featureToSave[suffixToSave];
                        switch (action) {
                            case "generate":
                                myManagerTrafficSignTool.BuildQrCode(featureInfoToSave.id, suffixToSave);
                                break;
                            case "download":
                                myManagerTrafficSignTool.GetQRCodePdf(featureInfoToSave.id);
                                break;
                            default:
                            // do nothing
                        }
                        break;
                    default:
                    // do nothing
                }
            });
        }

        // Event save/create sign
        if (mode == "update" || mode == 'create') {
            // Event save sign
            $('#' + idElementButtonSave).on('click', function () {
                var mode = $(this).attr('mode');
                var suffixToSave = $(this).attr('suffix');

                // Get layer info
                var layerInfoAll = myManagerTrafficSignTool._mapSgs.layerTree.GetLayerAllInfoArrayByLayerSourceName(myManagerTrafficSignTool.signInfo.layerName)[0];

                switch (mode) {
                    case "create":
                        // Create new sign feature
                        var newFeatureSign = new Feature({ geometry: myManagerTrafficSignTool._featurePrumoSelected.getGeometry() });

                        myManagerTrafficSignTool._SaveFeatureSign('insert', newFeatureSign, myManagerTrafficSignTool._featurePrumoSelected, myManagerTrafficSignTool.signInfo.layerNameSave, layerInfoAll.layer_info, suffixToSave, false);
                        break;
                    case "update":
                        var featureInfoToSave = myManagerTrafficSignTool._featureToSave[suffixToSave];
                        myManagerTrafficSignTool._SaveFeatureSign('update', featureInfoToSave.feature, featureInfoToSave.featurePrumo, myManagerTrafficSignTool.signInfo.layerNameSave, layerInfoAll.layer_info, suffixToSave, false);
                        break;
                    default:
                    // do nothing
                }
            });
        }

        // Download pdf qrcode
        //$('#' + idElementImgZone).on('click', function () {
        //    var qrCode = $('#' + idElementImg).attr("qr-code");
        //    myManagerTrafficSignTool._GetQRCodePdf(qrCode);
        //});

    }

    /**
     * Save a feature sign
     */
    this._SaveFeatureSign = function (mode, featureIn, featurePrumo, layerName, layerInfo, suffix, fromGeo, updateFromPrumo = false) {
        var addSuffix = (suffix) ? suffix : "";

        // Start wait
        myManagerTrafficSignTool._mapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', true);

        var props = {};
        if (!updateFromPrumo) {
            for (var i = 0; i < $('.feature-field', $('#id-offcanvas-body-layer-detail-field' + addSuffix)).length; i++) {
                var node = $('.feature-field', $('#id-offcanvas-body-layer-detail-field' + addSuffix))[i];
                //let fieldName = $(this).data('name');
                let fieldName = node.name;

                if (fieldName) {
                    let val = $(node).val();

                    if ($(node).attr("type") == "checkbox") {
                        val = $(node).prop('checked')
                    }

                    if (!$(node).is('[readonly]') || mode === 'insert')
                        props[fieldName] = val;
                }
            };
        }

        // Geometry column
        props[featureIn.getGeometryName()] = featurePrumo.getGeometry();

        // Set attribute from prumo
        var arrayAttribute = eval(myManagerTrafficSignTool.signInfo.signInfoConfig.list_column_to_update);
        for (var i = 0; i < arrayAttribute.length; i++) {
            var attribute = arrayAttribute[i];
            var columnNamePrumo = attribute[1];
            if (columnNamePrumo == myManagerTrafficSignTool.prumoInfo.prumoInfoConfig.column_name_id) {
                // Get id prumo from id feature
                props[attribute[0]] = featurePrumo.getId().split('.')[1];
            }
            else {
                props[attribute[0]] = featurePrumo.getProperties()[columnNamePrumo];
            }
        }

        // Set installed if insert
        if (mode == 'insert') {
            props["installed"] = true;
        }

        // Set installed if update
        if (mode == 'update' && props["installed"] == false) {
            props["id_prumo"] = null;
        }

        // Add properties to feature
        featureIn.setProperties(props);

        var formatWFS = new WFSFormat();
        var feature = featureIn.clone();
        if (mode == 'update')
            feature.setId(featureIn.getId());

        // Remove info column
        var arrayColumnToUnset = eval(myManagerTrafficSignTool.signInfo.signInfoConfig.list_column_to_unset);
        for (var p = 0; p < arrayColumnToUnset.length; p++) {
            feature.unset(arrayColumnToUnset[p]);
        }
        // Add geometry from prumo
        feature.unset(featureIn.getGeometryName());
        feature.setGeometryName(layerInfo.geomColumnName);
        feature.setGeometry(featurePrumo.getGeometry());
        // Set id
        if (mode == 'update')
            feature.setId(layerName + "." + featureIn.getId().split(".")[1]);

        var formatGML = new GMLFormat({
            featureNS: layerInfo.workspace,
            featureType: layerName,
            srsName: myManagerTrafficSignTool._mapSgs._settings.projection.getCode()
        });

        var node;
        switch (mode) {
            case 'insert':
                node = formatWFS.writeTransaction([feature], null, null, formatGML);
                // Remove all element empty
                $(node).find('*:empty').remove();
                break;
            case 'update':
                node = formatWFS.writeTransaction(null, [feature], null, formatGML);
                // Remove all property with null value
                $(node).find("Property:not(:has(Value))").remove();
                break;
            case 'delete':
                node = formatWFS.writeTransaction(null, null, [feature], formatGML);
                break;
        }

        var xs = new XMLSerializer();
        $(node).find('geometry').remove();
        var payload = xs.serializeToString(node);
        $.ajax(layerInfo.geoserver + '/' + layerInfo.workspace + '/ows?',
            {
                type: 'POST',
                dataType: 'application/xml',
                processData: false,
                contentType: 'application/xml',
                data: payload,
                success: function (data) {
                    var idFeature;
                    var stopSpinner = true;
                    switch (mode) {
                        case 'update':
                            if (feature.getId()) {
                                idFeature = (feature.getId().split(".")[1] !== undefined) ? layerInfo.layerName + "." + feature.getId().split(".")[1] : feature.getId();
                                delete myManagerTrafficSignTool._mapSgs.layerTree._cacheStyleFeature[idFeature]; // Remove from cache to refresh style again
                            }
                            break;
                        default:
                        // do nothing
                    }
                    // Refresh layer prumo
                    var layerInfoPrumo = myManagerTrafficSignTool._mapSgs.layerTree.GetLayerAllInfoArrayByLayerSourceName(myManagerTrafficSignTool.prumoInfo.layerName)[0].layer_info;

                    // Refresh layer sign
                    var layerTransactPrumo = myManagerTrafficSignTool._mapSgs._utility.GetLayerById(myManagerTrafficSignTool._mapSgs.map, 'T' + layerInfoPrumo.id);
                    if (layerTransactPrumo && layerTransactPrumo.getSource() instanceof VectorSource)
                        layerTransactPrumo.getSource().clear();

                    // Refresh layer sign
                    var layerTransact = myManagerTrafficSignTool._mapSgs._utility.GetLayerById(myManagerTrafficSignTool._mapSgs.map, 'T' + layerInfo.id);
                    if (layerTransact && layerTransact.getSource() instanceof VectorSource)
                        layerTransact.getSource().clear();

                    switch (mode) {
                        case "delete":
                            toastr["success"]('Sinal removido com sucesso');
                            app.Select.getFeatures().clear();
                            if (fromGeo)
                                myMapSgs.handleEditButtonsVisibility();
                            break;
                        case "insert":
                            idFeature = $((new DOMParser()).parseFromString(data.responseText, "text/xml").getElementsByTagName("ogc:FeatureId")[0]).attr("fid").split(".")[1];
                            // Build qrCode
                            if (idFeature) {
                                myManagerTrafficSignTool.BuildQrCode(idFeature, addSuffix, true);
                                stopSpinner = false;
                            }
                            // reload signals list
                            //myManagerTrafficSignTool.linkSignToPrumoParams.loadDataGrid();

                            // reload layers prumos and signals
                            myManagerTrafficSignTool.RefreshSignalingLayers();

                            let feature = myManagerTrafficSignTool._mapSgs._featureInfoFocus.feature;
                            const idLayer = myManagerTrafficSignTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(myManagerTrafficSignTool.prumoInfo.layerName)[0].id;

                            myManagerTrafficSignTool._mapSgs.DetailElement({
                                id: feature.getId().split(".")[1],
                                feature: feature,
                                idLayer: idLayer,
                                mode: 'update',
                                fromMap: true,
                                featurePrumo: feature
                            });

                            toastr["success"]('Sinal criado com sucesso');
                            break;
                        case "update":
                            toastr["success"]('Sinal gravado com sucesso');
                            break;
                        default:
                    }

                    // Close edition
                    if (fromGeo) {
                        myMapSgs.layerTree.CloseEdition(false);
                    }

                    // Stop wait
                    if (stopSpinner)
                        myManagerTrafficSignTool._mapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                },
                error: function (data) {
                    var parser = new DOMParser();
                    var xmlDoc = parser.parseFromString(data.responseText, "text/xml");
                    let errorData = $(xmlDoc.getElementsByTagName('ows:ExceptionText')).html();
                    let errorDetail = $(xmlDoc.getElementsByTagName('ows:Exception')).attr('exceptionCode');
                    let errorMessage = 'Erro gravação do Sinal.';
                    if (errorDetail == 'InvalidParameterValue') errorMessage += ' Campo com dados inválidos.';
                    if (errorDetail == 'InvalidValue') errorMessage += ' Campo com dados inválidos.';

                    if (errorData) {
                        toastr["error"](errorMessage);

                        // Stop wait
                        myManagerTrafficSignTool._mapSgs._utility.ShowWait('id-offcanvas-layer-detail-spinner', false);
                    } else this.success(data);
                }
            });
    };

    /**
    * Get all references for traffic sign tool
    */
    this._GetAllReferences = function () {
        $.ajax({
            type: 'GET',
            url: '/rest/app/ManagerTrafficSignTool/GetAllReference',
            async: false,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro de carregamento da informação de referência");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            myManagerTrafficSignTool._hashReference['listTipoSinal'] = data.result.listTipoSinal;
                            //myManagerTrafficSignTool._hashReference['listSubTipoSinalVertical'] = data.result.listSubTipoSinalVertical;

                            // Init panel selection type sign
                            myManagerTrafficSignTool.BuildTypeSignSelection('id-offcanvas-body-manager-traffice-sign-add-type-sign-append', 'id-offcanvas-body-manager-traffice-sign-add-type-sign-select2', '', 'SELECT_SIGN', "", "", "");
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro de carregamento da informação de referência");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro de carregamento da informação de referência");
            }
        });
    };

    /**
     * Build combo box select2 for type sign
     */
    this.BuildTypeSignSelection = function (idElementToAppend, idElementSelect2, name, action, value, multiple, style, attributeSelect2 = "", placeholder = "") {
        var $select = $('<select id="' + idElementSelect2 + '" name="' + name + '" ' + multiple + ' ' + style + ' class="form-control feature-field" title="Nenhum sinal escolhido" style="width: 100%" ' + attributeSelect2 + '></select>');
        var $option = $("<option></option>");
        $select.append($option);
        var length = myManagerTrafficSignTool._hashReference["listTipoSinal"].length;
        for (var u = 0; u < length; u++) {
            var typeElementObj = myManagerTrafficSignTool._hashReference["listTipoSinal"][u];
            var $option = $("<option></option>", {
                "text": typeElementObj.description,
                "value": typeElementObj.id,
                "img": typeElementObj.file_img_name
            });
            $select.append($option);
        }
        $('#' + idElementToAppend).append($select);
        $('#' + idElementSelect2).select2({
            width: 'resolve',
            placeholder: placeholder,
            templateResult: function (typeSignInfo) {
                var $span;
                if (typeSignInfo.id == "") {
                    $span = $('<span>' + typeSignInfo.text + '</span>');
                }
                else {
                    var img = $('#' + idElementSelect2 + ' option[value=' + typeSignInfo.id + ']').attr("img");
                    $span = $('<span><img src="' + img + '" width="20" height="20" style="margin-right: 10px;"/>' + typeSignInfo.text + '</span>');
                }
                return $span;
            },
            templateSelection: function (typeSignInfo) {
                var $span;
                if (typeSignInfo.id == "") {
                    $span = $('<span>' + typeSignInfo.text + '</span>');
                }
                else {
                    var img = $('#' + idElementSelect2 + ' option[value=' + typeSignInfo.id + ']').attr("img");
                    var style = 'style="margin-right: 10px;position: relative;bottom: 2px;"'
                    if (multiple != "") {
                        style = 'style="margin-right: 10px;position: relative;bottom: -2px;left: 5px;"'
                    }
                    $span = $('<span><img src="' + img + '" width="20" height="20" ' + style + '/><span>' + typeSignInfo.text + '</span></span>');
                }
                return $span;
            }
        });

        // Create Signal Selection Grid
        if (!myManagerTrafficSignTool['linkSignToPrumoParams']) {

            const idGrid = '#id-offcanvas-body-manager-traffice-sign-add-not-in-prumo';

            myManagerTrafficSignTool.linkSignToPrumoParams = {
                idTypeSignalSelected: ""
            };

            $(idGrid).kendoGrid({
                noRecords: {
                    template: '<div style="text-align:center;min-height:40px;width: 100%;align-content:center;"><span>Não existem resultados</span></div>'
                },
                columns: [
                    { field: "id", title: "TId Sinal", width: "10%" },
                    {
                        field: "id_tipo_sinal", title: " ", groupable: true, filterable: false, width: "5%",
                        template: (row) => row.file_img_name_sinal ? "<span style='cursor: pointer;'><img src='" + row.file_img_name_sinal + "' width='20' height='20' style='margin: 2px 10px 3px 5px;'/><span>" + row.tipo_sinal + "</span></span>" : ""
                    }
                ],
                dataSource: {
                     type: "json",
                    transport: {
                        read: {
                            url: "/ManagerTrafficSignTool/GridSearch",
                            type: 'POST',
                            dataType: "json",
                            data: (data) => {
                                data.filter = {
                                    filters: [{ field: "installed", operator: "eq", value: false }],
                                    logic: "and"
                                };
                                if (myManagerTrafficSignTool.linkSignToPrumoParams.idTypeSignalSelected != "") {
                                    data.filter.filters.push({
                                        field: "id_tipo_sinal", operator: "eq", value: myManagerTrafficSignTool.linkSignToPrumoParams.idTypeSignalSelected
                                    })
                                }
                                data.SchemaName = "traffic_signal";
                                data.TableName = "vw_sinalizacao_vertical_direcional";

                                return data;
                            }
                        }
                    },
                    schema: {
                        data: function (response) {
                            if (response.success) {
                                return response.result.data;
                            }
                            return [];
                        },
                        total: function (response) {
                            return response.result.total;
                        },
                        model: {
                            fields: {
                                id: { type: "string" },
                                id_tipo_sinal: { type: "string" }
                            }
                        }
                    },
                    pageSize: 5,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true
                },
                toolbar: [
                    { template: '<button type="button" disabled id="id-button-list-select-signal" title="Adicionar sinal" class="btn btn-primary" style="padding-top: 8px; padding-bottom: 8px;"><i class= "fa fa-link"></i></button>' }
                ],
                pageable: true,
                filterable: false,
                scrollable: false,
                sortable: false,
                groupable: false,
                pageable: {
                    info: false,
                    type: "numeric",
                    previousNext: true,
                    buttonCount: 2,
                    input: false
                },
                dataBound: function (e) {
                    $(idGrid).css('border-left', '0px');
                    $(idGrid).css('border-right', '0px');

                    var numbersWrapElement = $(idGrid).find('.k-pager-wrap');

                    if (numbersWrapElement) {
                        numbersWrapElement.find('.bootstrap-select.k-dropdown').hide();
                        numbersWrapElement.find('.k-pager-numbers').css('display', 'flex');
                        var pagerNavElements = numbersWrapElement.find('.k-pager-nav');

                        if (pagerNavElements.length > 2) {
                            pagerNavElements[2].style.marginLeft = '25px';
                        }
                    }
                },
                selectable: "multiple, row",
                change: function (e) {
                    const grid = e.sender;
                    var currentDataItem = grid.dataItem(this.select());

                    $("#id-button-list-select-signal").attr('disabled', currentDataItem == null);
                }
            });

            $(idGrid + " .k-grid-header").css('display', 'none');

            $("#id-button-list-select-signal").on("click", function (e) {

                var objPrumo = myManagerTrafficSignTool._mapSgs._featureInfoFocus.feature.getProperties();
                var grid = $(idGrid).data("kendoGrid");

                const selection = grid.select();
                let signals = [];

                selection.each(function (index, row) {
                    const objSignal = grid.dataItem(row);
                    signals.push(objSignal.id);
                });

                e.preventDefault();

                if (signals) {
                    myManagerTrafficSignTool.LinkSignToPrumo(
                        objPrumo.id,
                        signals,
                        () => {
                            // reload signals list
                            myManagerTrafficSignTool.linkSignToPrumoParams.loadDataGrid();
                            // reload layers prumos and signals
                            myManagerTrafficSignTool.RefreshSignalingLayers();

                            let feature = myManagerTrafficSignTool._mapSgs._featureInfoFocus.feature;
                            const idLayer = myManagerTrafficSignTool._mapSgs.layerTree.GetLayerInfoArrayByLayerSourceName(myManagerTrafficSignTool.prumoInfo.layerName)[0].id;

                            myManagerTrafficSignTool._mapSgs.DetailElement({
                                id: feature.getId().split(".")[1],
                                feature: feature,
                                idLayer: idLayer,
                                mode: 'update',
                                fromMap: true,
                                featurePrumo: feature
                            });
                        }
                    );
                }
            });

            myManagerTrafficSignTool.linkSignToPrumoParams.loadDataGrid = function () {
                $("#id-button-list-select-signal").attr('disabled', true);
                let grid = $(idGrid).data("kendoGrid");

                grid.clearSelection();
                grid.dataSource.page(1);
            }
        }

        // Event on selection
        switch (action) {
            case "SELECT_SIGN":
                $('#' + idElementSelect2).on('select2:select', function (e) {
                    var data = e.params.data;

                    // Get type sing column name
                    var signInfo = "";
                    var signInfoObj = myManagerTrafficSignTool._mapSgs._utility.GetPropertyInfoInConfigArray(myManagerTrafficSignTool._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "SIGN_INFO");
                    signInfo = JSON.parse(signInfoObj.value);
                    signInfo.column_name_type_sign

                    myManagerTrafficSignTool.linkSignToPrumoParams.idTypeSignalSelected = data.id;
                    myManagerTrafficSignTool.linkSignToPrumoParams.loadDataGrid();
                });
                break;
            case "REFRESH_TITLE_SIGN":
                break;
            case "REFRESH_TITLE_SIGN_IN_PRUMO":
                // Event on change type sign
                $('#' + idElementSelect2).on('select2:select', function () {
                    var valueSelected = $(this).val();
                    var idElementImg = 'id-offcanvas-body-layer-detail-img' + $(this).attr("suffix");
                    var idElementTitleLabel = 'id-offcanvas-body-layer-detail-title-label' + $(this).attr("suffix");
                    var signTypeInfo = myManagerTrafficSignTool._hashReference['listTipoSinal'].find(c => c.id == valueSelected);
                    $("#" + idElementImg).attr("src", signTypeInfo.file_img_name);
                    $("#" + idElementTitleLabel).html(signTypeInfo.description);
                    $("#" + idElementImg).show();
                });
                break;
            default:
            // do nothing
        }

        // Set value
        if (value != "") {
            $('#' + idElementSelect2).val(value).trigger('change');
        }
    }

    /**
     * Update Signal and Prumo Layers
     * */
    this.RefreshSignalingLayers = function () {

        // Refresh layer prumo
        var layerInfoPrumo = myManagerTrafficSignTool._mapSgs.layerTree.GetLayerAllInfoArrayByLayerSourceName(myManagerTrafficSignTool.prumoInfo.layerName)[0].layer_info;

        // Refresh layer sign
        var layerTransactPrumo = myManagerTrafficSignTool._mapSgs._utility.GetLayerById(myManagerTrafficSignTool._mapSgs.map, 'T' + layerInfoPrumo.id);
        if (layerTransactPrumo && layerTransactPrumo.getSource() instanceof VectorSource)
            layerTransactPrumo.getSource().clear();

        var layerInfoSign = myManagerTrafficSignTool._mapSgs.layerTree.GetLayerAllInfoArrayByLayerSourceName(myManagerTrafficSignTool.signInfo.layerName)[0].layer_info;

        // Refresh layer sign
        var layerTransact = myManagerTrafficSignTool._mapSgs._utility.GetLayerById(myManagerTrafficSignTool._mapSgs.map, 'T' + layerInfoSign.id);
        if (layerTransact && layerTransact.getSource() instanceof VectorSource)
            layerTransact.getSource().clear();
    }

    /**
     * Build combo box select2 for type sign in layer tree filter
     */
    this.BuildTypeSignSelectionForLayerTree = function (idElementToAppend, idElementSelect2, name, action, value, multiple, style, attributeSelect2 = "") {
        var $select = $('<select id="' + idElementSelect2 + '" name="' + name + '" ' + multiple + ' ' + style + ' class="form-control" title="Nenhum sinal escolhido" style="width: 100%" ' + attributeSelect2 + '></select>');
        var $option = $("<option></option>");
        $select.append($option);
        var length = myManagerTrafficSignTool._hashReference["listTipoSinal"].length;
        for (var u = 0; u < length; u++) {
            var typeElementObj = myManagerTrafficSignTool._hashReference["listTipoSinal"][u];
            var $option = $("<option></option>", {
                "text": typeElementObj.description,
                "value": typeElementObj.id,
                "img": typeElementObj.file_img_name
            });
            $select.append($option);
        }
        $('#' + idElementToAppend).append($select);
        $('#' + idElementSelect2).select2({
            width: 'resolve',
            templateResult: function (typeSignInfo) {
                var $span;
                if (typeSignInfo.id == "") {
                    $span = $('<span>' + typeSignInfo.text + '</span>');
                }
                else {
                    var img = $('#' + idElementSelect2 + ' option[value=' + typeSignInfo.id + ']').attr("img");
                    $span = $('<span><img src="' + img + '" width="18" height="18" style="margin-right: 10px;"/>' + typeSignInfo.text + '</span>');
                }
                return $span;
            },
            templateSelection: function (typeSignInfo) {
                var $span;
                if (typeSignInfo.id == "") {
                    $span = $('<span>' + typeSignInfo.text + '</span>');
                }
                else {
                    var img = $('#' + idElementSelect2 + ' option[value=' + typeSignInfo.id + ']').attr("img");
                    var style = 'style="margin-right: 10px;position: relative;bottom: 2px;"'
                    if (multiple != "") {
                        style = 'style="margin-right: 10px;position: relative;bottom: -4px;left: 2px;"'
                    }
                    $span = $('<span><img src="' + img + '" width="20" height="20" ' + style + '/><span></span></span>');
                }
                return $span;
            }
        });

        // Event on selection
        switch (action) {
            case "SELECT_SIGN":
                $('#' + idElementSelect2).on('select2:select', function (e) {
                    var data = e.params.data;

                    // Get type sing column name
                    var signInfo = "";
                    var signInfoObj = myManagerTrafficSignTool._mapSgs._utility.GetPropertyInfoInConfigArray(myManagerTrafficSignTool._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "SIGN_INFO");
                    signInfo = JSON.parse(signInfoObj.value);
                    signInfo.column_name_type_sign
                });
                break;
            case "REFRESH_TITLE_SIGN":
                break;
            case "REFRESH_TITLE_SIGN_IN_PRUMO":
                // Event on change type sign
                $('#' + idElementSelect2).on('select2:select', function () {
                    var valueSelected = $(this).val();
                    var idElementImg = 'id-offcanvas-body-layer-detail-img' + $(this).attr("suffix");
                    var idElementTitleLabel = 'id-offcanvas-body-layer-detail-title-label' + $(this).attr("suffix");
                    var signTypeInfo = myManagerTrafficSignTool._hashReference['listTipoSinal'].find(c => c.id == valueSelected);
                    $("#" + idElementImg).attr("src", signTypeInfo.file_img_name);
                    $("#" + idElementTitleLabel).html(signTypeInfo.description);
                    $("#" + idElementImg).show();
                });
                break;
            default:
            // do nothing
        }

        // Set value
        if (value != "") {
            $('#' + idElementSelect2).val(value).trigger('change');
        }
    }

    /**
    * Get road info by id
    */
    this._GetRoadInfoById = function (idArruamento) {
        var objArruamento = null;
        $.ajax({
            type: 'GET',
            url: '/rest/app/ManagerTrafficSignTool/GetRoadInfoById?idRoad=' + idArruamento,
            async: false,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da informação de arruamento");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            objArruamento = data.result.arruamento;
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na obtenção da informação de arruamento");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da informação de arruamento");
            }
        });

        return objArruamento;
    };

    /**
    * Get freguesia info by dicofre
    */
    this._GetFreguesiaInfoByDicofre = function (dicofre) {
        var objFreguesia = null;
        $.ajax({
            type: 'GET',
            url: '/rest/app/ManagerTrafficSignTool/GetFreguesiaInfoByDicofre?dicofre=' + dicofre,
            async: false,
            success: function (data) {
                if (data.error) {
                    toastr["error"]("Erro na obtenção da informação da freguesia");
                }
                else {
                    switch (data.result.status) {
                        case 'SUCCESS':
                            objFreguesia = data.result.freguesia;
                            break;
                        case 'ERROR':
                            toastr["error"]("Erro na obtenção da informação da freguesia");
                            break;
                        default:
                    }
                }
            },
            error: function (request, status, error) {
                toastr["error"]("Erro na obtenção da informação de freguesia");
            }
        });

        return objFreguesia;
    };

    /**
    * Get subtypes by selected type
    */
    this._GetSubtypesByType = function (type) {
        var subtypes = myManagerTrafficSignTool._hashReference['traffic_sign_subtypes'];

        var filteredSubtypes = subtypes.filter(function (el) {
            return el.t_SITIPO === type;
        });

        myManagerTrafficSignTool._utility.FillSelect('id-signSubtype', filteredSubtypes, 't_SISUBTIPO', 't_SISUBTIPO', true);
    };

    /**
    * Get signs by selected type and subtype
    */
    this._GetSignsByTypes = function (type, subtype) {
        var signs = myManagerTrafficSignTool._hashReference['traffic_sign_signs'];

        var filteredSigns = signs.filter(function (el) {
            return el.t_SITIPO === type && el.t_SISUBTIPO === subtype;
        });

        var signArea = $('#id-signArea')[0];

        for (var i = 0; i < filteredSigns.length; i++) {
            var signDiv = document.createElement('div');
            signDiv.id = 'signDiv' + filteredSigns[i].idrrvsinal;
            signDiv.style = "margin: 2px;";
            signDiv.innerHTML =
                `<input type="checkbox" id="${filteredSigns[i].idrrvsinal}" name="traffic-sign-checkbox">
                <label for="${filteredSigns[i].idrrvsinal}" style="margin-bottom: -10px; padding-right: 15%; margin-left: 10%;"></label>
                <img src="/images/traffic-signs/${filteredSigns[i].idrrvsinal}.bmp" alt="${filteredSigns[i].idrrvsinal}" height="20" width="20"> 
                ${filteredSigns[i].idrrvsinal}`;

            signArea.appendChild(signDiv);
        };
    };

    /**
     * Quick Search signal by id
     */
    this._QuickSearchSignalById = function (event) {
        myManagerTrafficSignTool._utility.ShowWait('offcanvas-map-spinner', true);

        event.preventDefault();

        // Build Filter
        //var cqlFilter = "";
        //var signType = $('#id-signType').val();
        //var signSubtype = $('#id-signArea').val();

        /*        var checkedSigns = myManagerTrafficSignTool._signsList;*/

        //if ($('#id-freguesia').val() !== "") {
        //    cqlFilter = "FREGUESIA = '" + $('#id-freguesia').find("option:selected").text() + "'";
        //}

        //if (signType !== "") {
        //    var typeQuery = `T_SITIPO = '${signType}'`;
        //    if (cqlFilter === "") {
        //        cqlFilter = typeQuery;
        //    } else {
        //        cqlFilter = `${cqlFilter} AND ${typeQuery}`;
        //    }
        //}

        //if (signSubtype !== "") {
        //    var subtypeQuery = `cod_sinal = '${id - signArea}'`;

        //    if (cqlFilter === "") {
        //        cqlFilter = subtypeQuery;
        //    } else {
        //        cqlFilter = `${cqlFilter} AND ${subtypeQuery}`;
        //    }
        //}

        //if (id !== "") {
        //    var subtypeQuery = `qrcode = '${qrcode}'`;

        //    if (cqlFilter === "") {
        //        cqlFilter = subtypeQuery;
        //    } else {
        //        cqlFilter = `${cqlFilter} AND ${subtypeQuery}`;
        //    }
        //}

        //if (checkedSigns.length > 0) {
        //    var signsQuery = "";
        //    var signsValues = "";

        //    checkedSigns.forEach(sign => {
        //        var fieldValue = `'${sign}'`;

        //        if (signsValues === "") {
        //            signsValues = fieldValue;
        //        } else {
        //            signsValues = `${signsValues}, ${fieldValue}`
        //        }
        //    });

        //    signsQuery = `IDRRVSINAL IN (${signsValues})`;

        //    if (cqlFilter === "") {
        //        cqlFilter = signsQuery;
        //    } else {
        //        cqlFilter = `${cqlFilter} AND ${signsQuery}`;
        //    }
        //}

        // Cql Filter
        var id = $('#id-traffic-sign-quick-search-id').val();
        var valid;
        Number.isFinite(parseInt(id)) ? valid = "1" : valid = "0";

        if (valid === "0") {
            toastr["error"]("Atenção, campo Identificador Inválido");
            // Stop wait
            myManagerTrafficSignTool._utility.ShowWait('offcanvas-map-spinner', false);
            return;
        }

        var cqlFilter = 'id=' + id;

        // Get features
        var layerName = myManagerTrafficSignTool.signInfo.layerName;
        var signInfoConfig = myManagerTrafficSignTool.signInfoConfig;
        var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfo(layerName);
        var getFeatureUrl = layerInfo.geoserver + "/wfs";
        var workspace = layerInfo.workspace;
        var cqlFilterLayer = layerInfo.cqlFilter;
        var cqlFilterResult = cqlFilter;
        if (cqlFilterLayer)
            cqlFilterResult += " And " + cqlFilterLayer;

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + layerName,
                "cql_filter": cqlFilterResult,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            myManagerTrafficSignTool._BuildSearchResult(data);
        });
    };

    /**
     * Quick Search signal by id
     */
    this._QuickSearchSignalById = function (event) {
        myManagerTrafficSignTool._utility.ShowWait('offcanvas-map-spinner', true);

        event.preventDefault();

        // Build Filter
        //var cqlFilter = "";
        //var signType = $('#id-signType').val();
        //var signSubtype = $('#id-signArea').val();

        /*        var checkedSigns = myManagerTrafficSignTool._signsList;*/

        //if ($('#id-freguesia').val() !== "") {
        //    cqlFilter = "FREGUESIA = '" + $('#id-freguesia').find("option:selected").text() + "'";
        //}

        //if (signType !== "") {
        //    var typeQuery = `T_SITIPO = '${signType}'`;
        //    if (cqlFilter === "") {
        //        cqlFilter = typeQuery;
        //    } else {
        //        cqlFilter = `${cqlFilter} AND ${typeQuery}`;
        //    }
        //}

        //if (signSubtype !== "") {
        //    var subtypeQuery = `cod_sinal = '${id - signArea}'`;

        //    if (cqlFilter === "") {
        //        cqlFilter = subtypeQuery;
        //    } else {
        //        cqlFilter = `${cqlFilter} AND ${subtypeQuery}`;
        //    }
        //}

        //if (id !== "") {
        //    var subtypeQuery = `qrcode = '${qrcode}'`;

        //    if (cqlFilter === "") {
        //        cqlFilter = subtypeQuery;
        //    } else {
        //        cqlFilter = `${cqlFilter} AND ${subtypeQuery}`;
        //    }
        //}

        //if (checkedSigns.length > 0) {
        //    var signsQuery = "";
        //    var signsValues = "";

        //    checkedSigns.forEach(sign => {
        //        var fieldValue = `'${sign}'`;

        //        if (signsValues === "") {
        //            signsValues = fieldValue;
        //        } else {
        //            signsValues = `${signsValues}, ${fieldValue}`
        //        }
        //    });

        //    signsQuery = `IDRRVSINAL IN (${signsValues})`;

        //    if (cqlFilter === "") {
        //        cqlFilter = signsQuery;
        //    } else {
        //        cqlFilter = `${cqlFilter} AND ${signsQuery}`;
        //    }
        //}

        // Cql Filter
        var id = $('#id-traffic-sign-quick-search-id').val();
        var valid;
        Number.isFinite(parseInt(id)) ? valid = "1" : valid = "0";

        if (valid === "0") {
            toastr["error"]("Atenção, identificador Inválido");
            // Stop wait
            myManagerTrafficSignTool._utility.ShowWait('offcanvas-map-spinner', false);
            return;
        }

        var cqlFilter = 'id=' + id;

        // Get features
        var layerName = myManagerTrafficSignTool.signInfo.layerName;
        var signInfoConfig = myManagerTrafficSignTool.signInfoConfig;
        var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfo(layerName);
        var getFeatureUrl = layerInfo.geoserver + "/wfs";
        var workspace = layerInfo.workspace;
        var cqlFilterLayer = layerInfo.cqlFilter;
        var cqlFilterResult = cqlFilter;
        if (cqlFilterLayer)
            cqlFilterResult += " And " + cqlFilterLayer;

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + layerName,
                "cql_filter": cqlFilterResult,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            myManagerTrafficSignTool._BuildSearchResult(data);
        });
        getFeature.fail(function (jqXHR, textStatus, errorThrown) {
            toastr["error"]("Erro na pesquisa de sinais por identificador");
            // Stop wait
            myManagerTrafficSignTool._utility.ShowWait('offcanvas-map-spinner', false);
        });
    };

    /**
     * Quick Search signal by address
     */
    this._QuickSearchSignalByAddress = function (event) {
        myManagerTrafficSignTool._utility.ShowWait('offcanvas-map-spinner', true);

        event.preventDefault();

        // Cql Filter
        var idAddress = $('#id-traffic-sign-quick-search-address-id').val();
        if (!idAddress && idAddress == undefined) {
            toastr["error"]("Morada inválida");
            // Stop wait
            myManagerTrafficSignTool._utility.ShowWait('offcanvas-map-spinner', false);
            return;
        }

        var valid;
        Number.isFinite(parseInt(idAddress)) ? valid = "1" : valid = "0";

        if (valid === "0") {
            toastr["error"]("Morada inválida");
            // Stop wait
            myManagerTrafficSignTool._utility.ShowWait('offcanvas-map-spinner', false);
            return;
        }

        var cqlFilter = 'id_morada=' + idAddress;

        // Get features
        var layerName = myManagerTrafficSignTool.signInfo.layerName;
        var signInfoConfig = myManagerTrafficSignTool.signInfoConfig;
        var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfo(layerName);
        var getFeatureUrl = layerInfo.geoserver + "/wfs";
        var workspace = layerInfo.workspace;
        var cqlFilterLayer = layerInfo.cqlFilter;
        var cqlFilterResult = cqlFilter;
        if (cqlFilterLayer)
            cqlFilterResult += " And " + cqlFilterLayer;

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + layerName,
                "cql_filter": cqlFilterResult,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            myManagerTrafficSignTool._BuildSearchResult(data);
        });
        getFeature.fail(function (jqXHR, textStatus, errorThrown) {
            toastr["error"]("Erro na pesquisa de sinais por morada");
            // Stop wait
            myManagerTrafficSignTool._utility.ShowWait('offcanvas-map-spinner', false);
        });
    };

    /**
     * Quick Search signal by type sign
     */
    this._QuickSearchSignalByTypeSign = function (event) {
        myManagerTrafficSignTool._utility.ShowWait('offcanvas-map-spinner', true);

        event.preventDefault();

        // Cql Filter
        var arrayTypeSign = $('#id-traffic-sign-quick-search-type-sign-zone-select2').val();
        if (!arrayTypeSign && arrayTypeSign == undefined) {
            toastr["warning"]("Seleccione pelo menos um tipo de sinal");
            // Stop wait
            myManagerTrafficSignTool._utility.ShowWait('offcanvas-map-spinner', false);
            return;
        }

        var arrayTypeSignStr = arrayTypeSign.toString();
        var cqlFilter = myManagerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign + ' in (' + arrayTypeSignStr + ')';

        // Get features
        var layerName = myManagerTrafficSignTool.signInfo.layerName;
        var signInfoConfig = myManagerTrafficSignTool.signInfoConfig;
        var layerInfo = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfo(layerName);
        var getFeatureUrl = layerInfo.geoserver + "/wfs";
        var workspace = layerInfo.workspace;
        var cqlFilterLayer = layerInfo.cqlFilter;
        var cqlFilterResult = cqlFilter;
        if (cqlFilterLayer)
            cqlFilterResult += " And " + cqlFilterLayer;

        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: getFeatureUrl,
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": workspace + ':' + layerName,
                "cql_filter": cqlFilterResult,
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            myManagerTrafficSignTool._BuildSearchResult(data);
        });
        getFeature.fail(function (jqXHR, textStatus, errorThrown) {
            toastr["error"]("Erro na pesquisa de sinais por tipo");
            // Stop wait
            myManagerTrafficSignTool._utility.ShowWait('offcanvas-map-spinner', false);
        });
    };

    /**
     * Build search result
     */
    this._BuildSearchResult = function (data) {
        if (data.features) {
            if (data.features.length > 0) {
                if (myManagerTrafficSignTool._mapSgs.featureToHighLight.getLength() > 0)
                    myManagerTrafficSignTool._mapSgs.featureToHighLight.clear();

                myManagerTrafficSignTool._mapSgs._arraySearchLayerFeatureActive = [];

                var feature = null;
                var layerName = myManagerTrafficSignTool.signInfo.layerName;
                var idLayer = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfo(layerName).id;
                var workspace = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfo(layerName).workspace;

                var columnDefArray = [];
                var columDefArrayExpand = [];
                var columDefArrayExpandSize = [];
                var columnValueArray = [];
                var idPrimaryKey = null;
                var featureHash = {};
                var firstFeature = true;
                for (let i = 0; i < data.features.length; i++) {
                    feature = (new GeoJSON()).readFeatures(data)[i];

                    if (feature.getGeometry() !== null) {

                        idPrimaryKey = feature.getId().split(".")[1];
                        featureHash[idPrimaryKey] = feature;

                        // Save feature Search
                        myManagerTrafficSignTool._mapSgs._arraySearchLayerFeatureActive.push(feature);

                        // Build column info
                        var objRow = {};
                        for (var j = 0; j < Object.keys(feature.getProperties()).length; j++) {
                            var columnName = Object.keys(feature.getProperties())[j];

                            if (columnName === "geometry")
                                continue;

                            var value = feature.getProperties()[columnName];
                            var columnProperties = myManagerTrafficSignTool._mapSgs.layerTree.layerInfo.dict_layer_info[idLayer].list_column.filter(obj => {
                                return obj.column_name === columnName
                            })[0];

                            // If value is a system date, format string
                            //if (new Date(value) != 'Invalid Date' && isNaN(value))
                            if (columnProperties) {
                                if (columnProperties.column_type == 'xsd:date-time')
                                    value = myManagerTrafficSignTool._utility.TransformDateServerInDateTime(value);

                                objRow[columnName] = value;
                                if (columDefArrayExpandSize[columnName]) {
                                    if (value) {
                                        var valueSize = value.toString().length;
                                        columDefArrayExpandSize[columnName] = (valueSize > columDefArrayExpandSize[columnName]) ? valueSize : columDefArrayExpandSize[columnName];
                                    }
                                }
                                else {
                                    if (value)
                                        columDefArrayExpandSize[columnName] = value.toString().length;
                                    else
                                        columDefArrayExpandSize[columnName] = 30; // If fist empty
                                }
                                if (firstFeature) {
                                    var columnSearchResult = myManagerTrafficSignTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result;
                                    var visible = myManagerTrafficSignTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).visible;
                                    var columnPrettyName = myManagerTrafficSignTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).pretty_name;
                                    var searchResultOrder = myManagerTrafficSignTool._mapSgs._settings.treeMap.dict_layer_info[idLayer].list_column.find(c => c.column_name === columnName).search_result_order;

                                    if (columnSearchResult) {
                                        // Type Sign
                                        if (myManagerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign == columnName) {
                                            columnDefArray.push({
                                                'data': columnName,
                                                'title': columnPrettyName,
                                                'name': columnPrettyName,
                                                'label': columnPrettyName,
                                                'type': columnPrettyName,
                                                'orderable': false,
                                                'width': '30px',
                                                'class': 'header-center',
                                                'search_order': searchResultOrder,
                                                'render': function (data, type, row) {
                                                    var idLayerSign = myManagerTrafficSignTool._mapSgs.layerTree.FindLayerInfo(myManagerTrafficSignTool.signInfo.layerName).id;
                                                    var idLayerReference = myManagerTrafficSignTool._mapSgs._settings.treeMap.dict_layer_info[idLayerSign].list_column.find(c => c.column_name === myManagerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign).id_rel_layer_column_ref_metadata;
                                                    var typeSignDesc = myManagerTrafficSignTool._mapSgs._settings.columnTableReferenceData.table_reference_data[idLayerReference].find(c => c.id == row[myManagerTrafficSignTool.signInfo.signInfoConfig.column_name_type_sign]).value;

                                                    //return '<div><div class="col-md-2" style="text-align: left;padding: 0px 0px 0px 5px;position: relative;top: 7px;"><img src="' + row.file_img_name_sinal + '" width="30" height="30"/></div><div class="col-md-8" style="position: relative;top: 3px;padding: 0px 0px 0px 5px;text-align: center;"><label>' + typeSignDesc + '</label><br/><label>' + row.id.toString().padStart(5, '0') + '</label></div></div>'
                                                    return '<div><div class="col-md-12" style="text-align: center;position: relative;bottom: 2px;" title="' + typeSignDesc + '"><img src="' + row.file_img_name_sinal + '" width="30" height="30"/></div></div>'
                                                }
                                            });
                                        }
                                        else if (myManagerTrafficSignTool.signInfo.signInfoConfig.column_name_id_sign == columnName) {
                                            columnDefArray.push({
                                                'data': columnName,
                                                'title': columnPrettyName,
                                                'name': columnPrettyName,
                                                'label': columnPrettyName,
                                                'type': columnPrettyName,
                                                'orderable': false,
                                                'width': '30px',
                                                'class': 'header-center',
                                                'search_order': searchResultOrder,
                                                'render': function (data, type, row) {
                                                    return myManagerTrafficSignTool._mapSgs._utility.PadLeft(data, 5);
                                                }
                                            });
                                        }
                                        else {
                                            columnDefArray.push({
                                                'data': columnName,
                                                'title': columnPrettyName,
                                                'name': columnPrettyName,
                                                'label': columnPrettyName,
                                                'type': columnPrettyName,
                                                'orderable': false,
                                                'width': '30px',
                                                'class': 'header-center',
                                                'search_order': searchResultOrder
                                            });
                                        }
                                    } else {
                                        columnDefArray.push({
                                            'data': columnName,
                                            'type': 'readonly',
                                            'visible': false,
                                            'search_order': 0
                                        });
                                    }
                                    if (visible) {
                                        columDefArrayExpand.push({
                                            'data': columnName,
                                            'title': columnPrettyName,
                                            'name': columnPrettyName,
                                            'label': columnPrettyName,
                                            'type': columnPrettyName,
                                            'orderable': false,
                                            'width': '30px'
                                        });
                                    }
                                    else {
                                        columDefArrayExpand.push({
                                            'data': columnName,
                                            'type': 'readonly',
                                            'visible': false
                                        });
                                    }
                                }
                            }
                        }
                        firstFeature = false;

                        // Order columns by search order
                        columnDefArray = columnDefArray.sort((a, b) => (a.search_order > b.search_order) ? 1 : -1);

                        // Add primary key value
                        objRow["id_primary_key"] = idPrimaryKey;

                        // Add array row
                        columnValueArray.push(objRow);

                        // Put in feature highlight
                        myManagerTrafficSignTool._mapSgs.featureToHighLight.push(feature);
                        var styleElement = myManagerTrafficSignTool._mapSgs._defaultHighlighStyles;
                        myManagerTrafficSignTool._mapSgs.featureToHighLight.getArray()[myManagerTrafficSignTool._mapSgs.featureToHighLight.getArray().length - 1].setStyle(styleElement);
                    }
                }

                // Add primary key to array
                columnDefArray.push({
                    'data': "id_primary_key",
                    'type': 'readonly',
                    'visible': false
                });

                columDefArrayExpand.push({
                    'data': "id_primary_key",
                    'type': 'readonly',
                    'visible': false
                });

                // Add size to column in array expand
                for (let i = 0; i < columDefArrayExpand.length; i++) {
                    var objDef = columDefArrayExpand[i];
                    if (objDef.width) {
                        if (columDefArrayExpandSize[objDef.data] > 50)
                            objDef.width = columDefArrayExpandSize[objDef.data].toString() + "px";
                        else
                            objDef.width = "50px";
                        columDefArrayExpand[i] = objDef;
                    }
                };

                // Show canvas search result
                myManagerTrafficSignTool._utility.ShowOpenCanvas3('offcanvas-search-result', true);

                // Make datatable list
                myManagerTrafficSignTool._mapSgs.InitSearchResultTable(workspace, layerName, idLayer, featureHash, columnDefArray, columDefArrayExpand, columnValueArray, myManagerTrafficSignTool._mapSgs.DetailElement);

                if (columnValueArray.length > 0) {
                    // Go to Feature
                    myManagerTrafficSignTool._mapSgs.map.getView().fit(myManagerTrafficSignTool._mapSgs.layerHighlightOverlay.getSource().getExtent(), { size: myManagerTrafficSignTool._mapSgs.map.getSize() });

                    // Set zoom if point
                    //myManagerTrafficSignTool._mapSgs.map.getView().setZoom(myManagerTrafficSignTool._mapSgs._settings.scales.indexOf(1000));
                } else {
                    toastr["warning"]("Não foi encontrado nenhum elemento");
                }

                // Remove hide in offcanvas search result information
                $('#id-offcanvas-search-result-zone').removeClass('ol-hidden');
                $('#id-offcanvas-search-result-body').removeClass('ol-hidden');
            }
            else {
                toastr["warning"]("Não foi encontrado nenhum elemento");
            }
        }

        // Stop wait
        myManagerTrafficSignTool._utility.ShowWait('offcanvas-map-spinner', false);
    };

    //this._GetQRCodePdf = function (idQrcode) {
    //    $.ajax({
    //        type: 'GET',
    //        url: abp.appPath + 'Maps/GetQRCodePdf?idQrcode=' + idQrcode,
    //        async: false,
    //        success: function (data) {
    //            var link = document.createElement('a');

    //            link.href = "data:application/octet-stream;base64," + data.result.dataPdf;
    //            link.target = '_blank';
    //            link.download = idQrcode + '.pdf';
    //            link.click();
    //        },
    //        error: function (request, status, error) {
    //            toastr["error"]("Erro na execução do download do qrcode");
    //        }
    //    });

    //}

    this._GetAllFeatureRoad = function () {
        // Call geoserver to get the feature of the layer
        var getFeature = $.ajax({
            method: "GET",
            async: true,
            url: '/geoserver/2' + '/wfs',
            data: {
                "service": 'wfs',
                "version": '2.0.0',
                "request": 'GetFeature',
                "typeNames": 'GP_CMA:carto_eixo_via_3',
                "outputFormat": 'application/json'
            }
        });

        // Response from the server
        getFeature.done(function (data, textStatus, jqXHR) {
            if (data.features.length > 0) {
                for (let i = 0; i < data.features.length; i++) {
                    var feature = (new GeoJSON()).readFeatures(data)[i];
                    myManagerTrafficSignTool.collectionFeatureRoadSet.push(feature);
                }
            }
        });
    }

    // -- end private method ----------------------------------------------------------------------

    // -- begin event -----------------------------------------------------------------------------

    $('#id-signType').on('changed.bs.select', function () {
        $("#id-signArea").empty();
        myManagerTrafficSignTool._GetSubtypesByType(this.value);
    });

    $('#id-signSubtype').on('changed.bs.select', function () {
        $("#id-signArea").empty();
        var type = $('#id-signType').val();
        myManagerTrafficSignTool._GetSignsByTypes(type, this.value);
    });

    /**
     * Event quick Search by id sign
     */
    $('#id-traffic-sign-quick-search-id-btn').on('click', myManagerTrafficSignTool._QuickSearchSignalById);

    /**
     * Event quick Search by address
     */
    $('#id-traffic-sign-quick-search-address-btn').on('click', myManagerTrafficSignTool._QuickSearchSignalByAddress);

    /**
     * Event quick Search by type sign
     */
    $('#id-traffic-sign-quick-search-type-sign-btn').on('click', myManagerTrafficSignTool._QuickSearchSignalByTypeSign);

    //$('#id-formTrafficSigns').on('submit', myManagerTrafficSignTool._QuickSearch);

    /**
     * Event on click add new sign
     */
    $('#id-offcanvas-body-manager-traffic-sign-tool-add-sign').on('click', function () {
        var statusSelect = $(this).attr("status-select");

        if (statusSelect == 'on') {
            // Hide selection
            $('#id-offcanvas-body-manager-traffice-sign-add-type-sign').hide();
            $('#id-offcanvas-body-manager-traffice-sign-add-not-in-prumo').hide();
            $(this).attr("status-select", "off");
        }
        else {

            //if (initSelect != 'on') {
            //    //var $select = $('#id-offcanvas-body-manager-traffice-sign-add-type-sig-select2');
            //    //var $option = $("<option></option>");
            //    //$select.append($option);

            //    //var length = myManagerTrafficSignTool._hashReference["listTipoSinal"].length;
            //    //for (var u = 0; u < length; u++) {
            //    //    var typeElementObj = myManagerTrafficSignTool._hashReference["listTipoSinal"][u];
            //    //    $option = $("<option></option>", {
            //    //        "text": typeElementObj.description,
            //    //        "value": typeElementObj.id//,
            //    //        //"img": typeElementObj.file_img_name
            //    //    });
            //    //    $select.append($option);
            //    //}
            //    //var arrayTypeSign = myManagerTrafficSignTool._hashReference["listTipoSinal"].map(function (typeElementInfo) { return { id: typeElementInfo.id, text: typeElementInfo.description } });
            //    //$('#id-offcanvas-body-manager-traffice-sign-add-type-sign-select2').select2({
            //    //    placeholder: "Nenhum tipo de elemento seleccionado",
            //    //    data: arrayTypeSign,
            //    //    allowClear: true,
            //    //    dropdownParent: $('#id-div-canvas-body-detail')
            //    //});
            //    //$('#id-offcanvas-body-manager-traffice-sign-add-type-sign-select2').select2();
            //    $('#id-offcanvas-body-manager-traffic-sign-tool-add-sign').attr("init-select", "on");
            //}
            // Show selection
            $('#id-offcanvas-body-manager-traffice-sign-add-type-sign').show();
            $('#id-offcanvas-body-manager-traffice-sign-add-not-in-prumo').show();
            $(this).attr("status-select", "on");
        }
    })

    /**
     * Event on click create new sign
     */
    $('#id-offcanvas-body-manager-traffic-sign-tool-create-sign').on('click', function () {
        var statusCreated = $(this).attr("status-created");

        if (statusCreated == 'on') {
            // Remove form
            var lastSuffixCreated = $(this).attr("last-suffix-created");
            $('#id-offcanvas-body-layer-detail-zone' + lastSuffixCreated).remove();
            $('#id-offcanvas-body-layer-detail-zone' + lastSuffixCreated + "-separator").remove();
            $(this).attr("status-created", "off");
            $(this).attr("last-suffix-created", "");
        }
        else {
            // Add form new sign
            var idPrumo = $(this).attr("id-prumo");
            myManagerTrafficSignTool._positionSuffix = myManagerTrafficSignTool._positionSuffix + 1;
            var suffix = "-" + myManagerTrafficSignTool._positionSuffix;

            // Create structure for new sign
            myManagerTrafficSignTool._AddNewSign(myManagerTrafficSignTool.signInfo.layerName, suffix, "create", "", idPrumo, "", "nenhum tipo de sinal seleccionado");
            $(this).attr("last-suffix-created", suffix);
            $(this).attr("status-created", "on");
        }
    })

    //$('#id-offcanvas-layer-detail-qrcopde-img-zone').on('click', function () {
    //    var qrCode = $('#id-offcanvas-layer-detail-qrcopde-img-to-zoom').attr("qr-code");
    //    myManagerTrafficSignTool._GetQRCodePdf(qrCode);
    //});

    // Event generate qr code
    $('#id-offcanvas-body-layer-detail-generate-qrcode').on('click', function () {
        var mode = $(this).attr('mode');
        var action = $(this).attr('action');
        var idSign = $(this).attr('sign-id');

        switch (mode) {
            case "read":
            case "update":
                switch (action) {
                    case "generate":
                        myManagerTrafficSignTool.BuildQrCode(idSign, "");
                        break;
                    case "download":
                        myManagerTrafficSignTool.GetQRCodePdf(idSign);
                        break;
                    default:
                    // do nothing
                }
                break;
            default:
            // do nothing
        }
    });

    // -- end event -------------------------------------------------------------------------------
};

/**
 * Init traffic sign tool
 * @param {object} mapSgs, map object
 */
ManagerTrafficSignTool.prototype.Init = function (mapSgs) {
    if (!this._toolInitialize) {
        this._toolInitialize = true;

        // Set map info
        this._mapSgs = mapSgs;

        // -- Get sign info - begin ---------------------------------------------------------------

        // Get sign info config
        var signInfoObj = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "SIGN_INFO");
        if (signInfoObj && signInfoObj.value) {
            this.signInfo["signInfoConfig"] = JSON.parse(signInfoObj.value);
        }

        // Get layer sign name;
        this.signInfo["layerName"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "SIGN_LAYER_NAME").value;

        // Get layer sign name to save;
        this.signInfo["layerNameSave"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "SIGN_LAYER_NAME_FOR_SAVE").value;

        // Get prumo id column name
        this.signInfo["columnNameIdPrumo"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "PRUMO_ID_COLUMN_NAME").value;

        // -- Get sign info - end -----------------------------------------------------------------

        // -- Get prumo info - begin --------------------------------------------------------------

        // Get sign info config
        var prumoInfoObj = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "PRUMO_INFO");
        if (prumoInfoObj && prumoInfoObj.value) {
            this.prumoInfo["prumoInfoConfig"] = JSON.parse(prumoInfoObj.value);
        }

        // Get layer prumo name;
        this.prumoInfo["layerName"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "PRUMO_LAYER_NAME").value;

        // Get json sinal prumo column
        this.prumoInfo["columnJsonSinal"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "PRUMO_SINAL_COLUMN_NAME").value;

        // Get layer prumo name to save;
        this.prumoInfo["layerNameSave"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "PRUMO_LAYER_NAME_FOR_SAVE").value;

        // -- Get prumo info - end ----------------------------------------------------------------

        // -- Get road info - begin ---------------------------------------------------------------

        // Get layer name used for road visualization in map
        this.roadInfo["layerNameView"] = 'carto_eixo_via_2';

        // Get layer name used for road process in map
        this.roadInfo["layerNameProcess"] = 'carto_eixo_via_3';

        // Get column name of the road name
        this.roadInfo["columnNameRoadName"] = 'namevia';

        // Get column name id road in layer name process
        this.roadInfo["columnNameIdRoad"] = 'id_eixo_via';

        // -- Get road info - end -----------------------------------------------------------------

        // -- Get support light sign info - begin -------------------------------------------------

        // -- Get support light sign info - end ---------------------------------------------------

        // Get support light sign layer name
        this.supportLightSignInfo["layerName"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "SUPPORT_LIGHT_SINAL_LAYER_NAME").value;

        // Get json sinal support light sign column
        this.supportLightSignInfo["columnJsonSinal"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "SUPPORT_LIGHT_SINAL_COLUMN_NAME").value;

        // -- Get light sign info - begin ---------------------------------------------------------

        // Get layer name light sign
        this.lightSignInfo["layerName"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "LIGHT_SIGN_LAYER_NAME").value;

        // -- Get light sign info - end -----------------------------------------------------------

        // -- Get bus stop info - begin -----------------------------------------------------------

        // Get layer name bus stop
        this.busStopInfo["layerName"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "BUS_STOP_LAYER_NAME").value;

        // -- Get bus stop info - end -------------------------------------------------------------

        // -- Get toponymic plate info - begin ----------------------------------------------------

        // Get layer name toponymic plate
        this.toponymicPlateInfo["layerName"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "TOPONYMIC_PLATE_LAYER_NAME").value;

        // -- Get toponymic plate info - end ------------------------------------------------------

        // -- Get beacon info - begin -------------------------------------------------------------

        // Get layer name beacon
        this.beaconInfo["layerName"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "BEACON_LAYER_NAME").value;

        // -- Get beacon info - end ---------------------------------------------------------------

        // -- Get guarda corpos info - begin ------------------------------------------------------

        // Get layer name guarda corpos
        this.guardaCorposInfo["layerName"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "GUARDA_CORPOS_LAYER_NAME").value;

        // -- Get guarda corpos info - end --------------------------------------------------------

        // -- Get new jersey info - begin ---------------------------------------------------------

        // Get layer name new jersey
        this.newJerseyInfo["layerName"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "NEW_JERSEY_LAYER_NAME").value;

        // -- Get new jersey info - end -----------------------------------------------------------

        // -- Get pilarete info - begin -----------------------------------------------------------

        // Get layer name pilarete
        this.pilareteInfo["layerName"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "PILARETE_LAYER_NAME").value;

        // -- Get pilarete info - end -------------------------------------------------------------

        // -- Get marcador info - begin -----------------------------------------------------------

        // Get layer name pilarete
        this.marcadorInfo["layerName"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "MARCADOR_LAYER_NAME").value;

        // -- Get marcador info - end -------------------------------------------------------------

        // -- Get rail info - begin ---------------------------------------------------------------

        // Get layer name pilarete
        this.railInfo["layerName"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "RAIL_LAYER_NAME").value;

        // -- Get rail info - end -----------------------------------------------------------------

        // -- Get lomba info - begin --------------------------------------------------------------

        // Get layer name pilarete
        this.lombaInfo["layerName"] = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "LOMBA_LAYER_NAME").value;

        // -- Get lomba info - end ----------------------------------------------------------------

        // -- Get config info - begin -------------------------------------------------------------

        // Get scale icon information
        this.configInfo["scale"] = parseFloat(this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "SCALE_ICON").value);

        // -- Get config info - end ---------------------------------------------------------------

        // Get layer name for traffice sign
        this.arrayLayerNameTrafficSign = this._utility.GetPropertyInfoInConfigArray(this._mapSgs._settings.configurationInfo.propertyInfo, "TRAFFIC_SIGNAL_CONFIG", "LAYER_TRAFFIC_SIGN", "ARRAY_LAYER_NAME").value.split(',');;

        // Layer sub road traffic sign closer
        this._layerSubRoadCloser = new VectorLayer({
            source: new VectorSource({
                format: new GeoJSON()
            }),
            style: this._styleSubRoadCloser
        });
        this._mapSgs.map.addLayer(this._layerSubRoadCloser);

        // -- Get all references --
        this._GetAllReferences();

        // Build select2 search type of signal
        this.BuildTypeSignSelection("id-traffic-sign-quick-search-type-sign-zone-append", "id-traffic-sign-quick-search-type-sign-zone-select2", "", "", "", 'multiple="multiple"', "", "", "Seleccione pelo menos um tipo de sinal");

        // Fill collection feature with all road feature
        //this._GetAllFeatureRoad();
    }
};